export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  JSON: any;
  NodeValue: any;
};

export type ActionConfig = {
  contentTypeGroups?: Maybe<Array<Scalars['String']>>;
  iconOnly?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export enum AdditionalInfoFieldType {
  Boolean = 'boolean',
  Number = 'number',
  Text = 'text'
}

export type AdditionalInfoInput = {
  fieldCode?: InputMaybe<Scalars['String']>;
  fieldName?: InputMaybe<Scalars['String']>;
  fieldType?: InputMaybe<AdditionalInfoFieldType>;
  jsonDataFormula?: InputMaybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  showOnLinkTable: Scalars['Boolean'];
};

export type AdditionalInfoType = {
  fieldCode?: Maybe<Scalars['String']>;
  fieldName?: Maybe<Scalars['String']>;
  fieldType?: Maybe<AdditionalInfoFieldType>;
  jsonDataFormula?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  showOnLinkTable: Scalars['Boolean'];
};

/**
 * Signal that an agent run changed: a new step was recorded or its status moved. It carries no run
 * content; the client re-reads the run through the authenticated REST API GET /api/agents/runs/:id.
 */
export type AgentRunUpdate = {
  runId: Scalars['ID'];
  seq?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type AlignModelGlsResponse = {
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  successfullyUpdatedGls: Array<Scalars['String']>;
};

export type ApproveNodeTranslationsNodeResult = {
  approvedCount: Scalars['Int'];
  nodeId: Scalars['String'];
};

export type ApproveNodeTranslationsResponse = {
  approvedCount: Scalars['Int'];
  nodes: Array<ApproveNodeTranslationsNodeResult>;
};

export type AssignedNodeRef = {
  code: Scalars['String'];
  id: Scalars['String'];
  listName?: Maybe<Scalars['String']>;
};

/** Which direct links of a node an assignment is copied to, and whether the caller is asked first. */
export type AssignmentPropagation = {
  direction: AssignmentPropagationDirection;
  mode: AssignmentPropagationMode;
  /** Only linked nodes whose hierarchy uses one of these object schemas; empty = every schema. */
  objectSchemaCodes?: Maybe<Array<Scalars['String']>>;
};

export enum AssignmentPropagationDirection {
  Both = 'both',
  Linked = 'linked',
  LinkedBy = 'linkedBy',
  None = 'none'
}

export type AssignmentPropagationInput = {
  direction: AssignmentPropagationDirection;
  mode: AssignmentPropagationMode;
  objectSchemaCodes?: InputMaybe<Array<Scalars['String']>>;
};

export enum AssignmentPropagationMode {
  Ask = 'ask',
  Auto = 'auto'
}

export type AttachmentsParams = {
  authUrl: Scalars['String'];
  baseUrl: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  linkParameter: Scalars['String'];
  scope: Scalars['String'];
  sharepointBaseLink: Scalars['String'];
};

export type BoomiParams = {
  authUrl: Scalars['String'];
  baseUrl: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  commonXApiKey: Scalars['String'];
  scope: Scalars['String'];
  xApiKeySap?: Maybe<Scalars['String']>;
  zeusXApiKey: Scalars['String'];
};

export type BreadcrumbNode = {
  code: Scalars['String'];
  id: Scalars['String'];
  listName?: Maybe<Scalars['String']>;
};

export type BuildUpDiff = {
  familyId: Scalars['String'];
  prototypes: Array<BuildUpDiffPrototype>;
};

export type BuildUpDiffPrototype = {
  fields: Array<BuildUpDiffPrototypeField>;
  prototypeCode: Scalars['String'];
  prototypeId: Scalars['String'];
};

export type BuildUpDiffPrototypeField = {
  certified?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  draft?: Maybe<Scalars['String']>;
};

export type BulkNodeContent = {
  children?: InputMaybe<Array<BulkNodeContent>>;
  code: Scalars['String'];
  contents: Array<NodeContent>;
  parent: Scalars['String'];
};

export type BulkNodes = {
  contents: Array<NodeContent>;
  node: Scalars['String'];
};

export type CadPreviewSettings = {
  enabled: Scalars['Boolean'];
  type: Scalars['String'];
};

export type CascadeDeleteGroup = {
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  items: Array<CascadeDeleteItem>;
  objectSchemaCode: Scalars['String'];
  totalCount: Scalars['Int'];
};

export type CascadeDeleteItem = {
  code: Scalars['String'];
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  listName?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  reason: CascadeDeleteReason;
  /** Code of the node this row depends on: the one it links to, or the ancestor dragging it. */
  viaCode?: Maybe<Scalars['String']>;
};

export type CascadeDeleteLockedNode = {
  code: Scalars['String'];
  hierarchyId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
};

/**
 * Everything a cascading delete removes *in addition to* the target and its own subtree, which the
 * caller already knows from `getLinkedNodesForDelete`. `capExceeded` means the plan is partial and
 * the cascade cannot be executed.
 */
export type CascadeDeletePreviewResult = {
  capExceeded: Scalars['Boolean'];
  groups: Array<CascadeDeleteGroup>;
  /** Nodes in the plan that are read-only: while any is present the cascade cannot run. */
  lockedNodes: Array<CascadeDeleteLockedNode>;
  total: Scalars['Int'];
};

/** Why a node is part of a cascading delete. */
export enum CascadeDeleteReason {
  /** Its ancestor is being deleted, so it goes with the subtree. */
  Descendant = 'descendant',
  /** It links into something the delete removes. */
  Links = 'links'
}

export type CertificationResponse = {
  documentId?: Maybe<Scalars['String']>;
  salesforceDocumentId?: Maybe<Scalars['String']>;
};

export type CertificationStatus = {
  certified: Scalars['String'];
  certifiedDraft: Scalars['String'];
  certifiedError: Scalars['String'];
  certifiedInCertification: Scalars['String'];
  certifiedPublished: Scalars['String'];
  draft: Scalars['String'];
  error: Scalars['String'];
  inCertification: Scalars['String'];
};

export type CgtModelVariables = {
  base_program: Scalars['Float'];
  biased: Scalars['Float'];
  c1: Scalars['Float'];
  c2: Scalars['Float'];
  c3: Scalars['Float'];
  cash_discount: Scalars['Float'];
  cgtModelId: Scalars['String'];
  conquest: Scalars['Float'];
  cva: Scalars['Float'];
  dealer_discount: Scalars['Float'];
  extra_value_support: Scalars['Float'];
  incentive_volume: Scalars['Float'];
  lc: Scalars['Float'];
  sv: Scalars['Float'];
};

export type CgtSettings = {
  alwaysEditableServiceContractRate?: Maybe<Scalars['Boolean']>;
  attachmentsParams?: Maybe<AttachmentsParams>;
  boomiParams?: Maybe<BoomiParams>;
  catImportNotificationEmails?: Maybe<Array<Scalars['String']>>;
  coolsalesExporter: CoolsalesExporter;
  disableChangeParentHierarchy?: Maybe<Array<Scalars['String']>>;
  disableCreateFromHierarchy?: Maybe<Array<Scalars['String']>>;
  discountMPRoles: Array<DiscountMpRoles>;
  enableAssetConGerarchia?: Maybe<Scalars['Boolean']>;
  enableAutoPriceAlignment?: Maybe<Scalars['Boolean']>;
  enableDatabIsoDate?: Maybe<Scalars['Boolean']>;
  enableReplaceLinkHierarchy?: Maybe<Array<Scalars['String']>>;
  exportMediaDocumentFields?: Maybe<Scalars['Boolean']>;
  exportZembGls?: Maybe<Scalars['Boolean']>;
  exporter: Exporter;
  fields: FieldsSetting;
  filterServiceContractByAvailableForSimpleAsset?: Maybe<Scalars['Boolean']>;
  forceCertificateButtonActive: Scalars['Boolean'];
  glMediaCategoryMapping?: Maybe<GlMediaCategoryMapping>;
  groups: GroupsSetting;
  hierarchies: HierarchiesSetting;
  hintoParams?: Maybe<HintoParams>;
  listiniPerZMABCode: Scalars['String'];
  manodoperaSupplierId: Scalars['String'];
  microsoftGraphParams?: Maybe<MicrosoftGraphParams>;
  objectSchemas: ObjectSchemasSetting;
  paths: PathsSetting;
  pricelistCatNodeCode: Scalars['String'];
  prototypeMediaCategoryMapping?: Maybe<PrototypeMediaCategoryMapping>;
  prototypeSetting: PrototypeSetting;
  showNodeStatuses: Scalars['Boolean'];
  skipCertificate: Scalars['Boolean'];
  skipExport: Scalars['Boolean'];
  skipHinto: Scalars['Boolean'];
  skipPublish: Scalars['Boolean'];
  skipStatus: Scalars['Boolean'];
  useDynamicRules?: Maybe<Scalars['Boolean']>;
  warrantyPublish?: Maybe<WarrantyPublishSetting>;
};

export type ChannelSetting = {
  code: Scalars['String'];
  label?: Maybe<Scalars['JSON']>;
  locales: Array<Scalars['String']>;
  schemaCodes?: Maybe<Array<Scalars['String']>>;
};

export type ChartClickAction = {
  path?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ChartFilterConfig = {
  field: Scalars['String'];
  operator: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type CheckResponse = {
  codes?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ClientConfig = {
  clientId: Scalars['String'];
  endpoint: Scalars['String'];
  listId: Scalars['String'];
  secret: Scalars['String'];
};

export type ClientConfigInput = {
  clientId: Scalars['String'];
  endpoint: Scalars['String'];
  listId: Scalars['String'];
  secret: Scalars['String'];
};

/**
 * A GL selectable for a compatibility rule, with the prototypes it comes from in the approved version
 * the rule is authored against. A GL carried by that version lists its own prototype alone.
 */
export type CompatibilityRuleGlSource = {
  glId: Scalars['String'];
  prototypeNames: Array<Scalars['String']>;
};

export type CompatiblePriceList = {
  compatibilePriceLists?: Maybe<Array<PriceListInfo>>;
  compatibilePriceListsZMAB?: Maybe<Array<PriceListInfo>>;
  disabledPriceListId?: Maybe<Scalars['String']>;
};

/**
 * Which node contents a search matches: DRAFT (default) the current contents, PUBLISHED the
 * published version of the nodes (only nodes that have one). PUBLISHED requires the
 * searchOptimization.publishedContentGraphQueries setting: globalSearch fails without it, while
 * searchHierarchies falls back to the draft nodes.
 */
export enum ContentSource {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ContentType = {
  additionalInfo?: Maybe<Array<Maybe<AdditionalInfoType>>>;
  allowDuplicateOptionsCode?: Maybe<Scalars['Boolean']>;
  allowExternalUrl?: Maybe<Scalars['Boolean']>;
  allowPastDates?: Maybe<Scalars['Boolean']>;
  autoFilled?: Maybe<Scalars['Boolean']>;
  client?: Maybe<ClientConfig>;
  code: Scalars['String'];
  columnSize?: Maybe<Scalars['String']>;
  compactView?: Maybe<Scalars['Boolean']>;
  creatable?: Maybe<Scalars['Boolean']>;
  defaultValueExpression?: Maybe<Scalars['String']>;
  depthFilter?: Maybe<Scalars['String']>;
  disableEditAction?: Maybe<Scalars['Boolean']>;
  disableNodeCreation?: Maybe<Scalars['Boolean']>;
  disableThousandsSeparator?: Maybe<Scalars['Boolean']>;
  disallowEqualCodeAndValue?: Maybe<Scalars['Boolean']>;
  dynamicFilters?: Maybe<Array<Filters>>;
  dynamicReadonly?: Maybe<DynamicReadonly>;
  dynamicRegex?: Maybe<Array<DynamicRegex>>;
  enableRange?: Maybe<Scalars['Boolean']>;
  enableXlsxExport?: Maybe<Scalars['Boolean']>;
  encryptAtRest?: Maybe<Scalars['Boolean']>;
  filters?: Maybe<Array<Filters>>;
  hidden?: Maybe<Scalars['Boolean']>;
  hierarchy?: Maybe<Scalars['String']>;
  /** Multi-language content types: an inherited value is rendered read-only. Absent means true. */
  inheritedReadOnly?: Maybe<Scalars['Boolean']>;
  isMainImage?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  link?: Maybe<Array<Maybe<Scalars['String']>>>;
  mandatory: Scalars['Boolean'];
  mandatoryForSave?: Maybe<MandatoryForSaveCondition>;
  maskOnUi?: Maybe<Scalars['Boolean']>;
  mediaFolder?: Maybe<Scalars['String']>;
  multiLanguage: Scalars['Boolean'];
  multiLine?: Maybe<Scalars['Boolean']>;
  multiValue: Scalars['Boolean'];
  name: Array<NameObject>;
  optionalValues?: Maybe<Array<SelectOptionValues>>;
  optionsSource?: Maybe<OptionsSource>;
  readOnly?: Maybe<Scalars['Boolean']>;
  regex?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  showAsColumnWhenHidden?: Maybe<Scalars['Boolean']>;
  showAsPercentage?: Maybe<Scalars['Boolean']>;
  showCode?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  viewRoles?: Maybe<Array<Scalars['String']>>;
  visibility?: Maybe<Visibility>;
  workflowCode?: Maybe<Scalars['String']>;
};

export type ContentTypeGroup = {
  approveRoles?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  collapsed?: Maybe<Scalars['Boolean']>;
  contentTypes?: Maybe<Array<ContentType>>;
  name: Array<NameObject>;
  repeatable: Scalars['Boolean'];
  roles?: Maybe<Scalars['String']>;
  showLevel?: Maybe<Scalars['String']>;
  viewRoles?: Maybe<Array<Scalars['String']>>;
};

export type ContentTypeGroupI = {
  approveRoles?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  collapsed: Scalars['Boolean'];
  name: Array<NameObjectI>;
  repeatable: Scalars['Boolean'];
  roles?: InputMaybe<Scalars['String']>;
  showLevel?: InputMaybe<Scalars['String']>;
  viewRoles?: InputMaybe<Array<Scalars['String']>>;
};

export type ContentTypeGroupStatus = {
  code: Scalars['String'];
  publishedAt?: Maybe<Scalars['String']>;
  status: CtgStatus;
};

export type ContentTypeInput = {
  additionalInfo?: InputMaybe<Array<AdditionalInfoInput>>;
  allowDuplicateOptionsCode?: InputMaybe<Scalars['Boolean']>;
  allowExternalUrl?: InputMaybe<Scalars['Boolean']>;
  allowPastDates?: InputMaybe<Scalars['Boolean']>;
  autoFilled?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<ClientConfigInput>;
  code: Scalars['String'];
  columnSize?: InputMaybe<Scalars['String']>;
  compactView?: InputMaybe<Scalars['Boolean']>;
  creatable?: InputMaybe<Scalars['Boolean']>;
  defaultValueExpression?: InputMaybe<Scalars['String']>;
  depthFilter?: InputMaybe<Scalars['String']>;
  disableEditAction?: InputMaybe<Scalars['Boolean']>;
  disableNodeCreation?: InputMaybe<Scalars['Boolean']>;
  disableThousandsSeparator?: InputMaybe<Scalars['Boolean']>;
  disallowEqualCodeAndValue?: InputMaybe<Scalars['Boolean']>;
  dynamicFilters?: InputMaybe<Array<FiltersInput>>;
  dynamicReadonly?: InputMaybe<DynamicReadonlyInput>;
  dynamicRegex?: InputMaybe<Array<DynamicRegexInput>>;
  enableRange: Scalars['Boolean'];
  enableXlsxExport?: InputMaybe<Scalars['Boolean']>;
  encryptAtRest?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<FiltersInput>>;
  hidden: Scalars['Boolean'];
  hierarchy?: InputMaybe<Scalars['String']>;
  inheritedReadOnly?: InputMaybe<Scalars['Boolean']>;
  isMainImage?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Array<Scalars['String']>>;
  mandatory: Scalars['Boolean'];
  mandatoryForSave?: InputMaybe<MandatoryForSaveConditionInput>;
  maskOnUi?: InputMaybe<Scalars['Boolean']>;
  mediaFolder?: InputMaybe<Scalars['String']>;
  multiLanguage: Scalars['Boolean'];
  multiLine?: InputMaybe<Scalars['Boolean']>;
  multiValue: Scalars['Boolean'];
  name: Array<NameObjectI>;
  optionalValues?: InputMaybe<Array<SelectOptionValuesInput>>;
  optionsSource?: InputMaybe<OptionsSourceInput>;
  readOnly: Scalars['Boolean'];
  regex?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showAsColumnWhenHidden?: InputMaybe<Scalars['Boolean']>;
  showAsPercentage?: InputMaybe<Scalars['Boolean']>;
  showCode?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
  viewRoles?: InputMaybe<Array<Scalars['String']>>;
  visibility: VisibilityInput;
  workflowCode?: InputMaybe<Scalars['String']>;
};

export type CoolsalesExporter = {
  couch: Couch;
};

export type Couch = {
  dbName: Scalars['String'];
  dbUri: Scalars['String'];
};

export type CpqChainedConfigProductIdMapping = {
  optionValue: Scalars['String'];
  productId: Scalars['String'];
};

export type CpqChainedConfiguration = {
  enable: Scalars['Boolean'];
  optionMappingsHierarchyId: Scalars['String'];
  productIdMapping?: Maybe<Array<CpqChainedConfigProductIdMapping>>;
  productSelectorFeatureCode: Scalars['String'];
};

export type CpqConfiguratorSettings = {
  defaultGroupsExpanded?: Maybe<Scalars['Boolean']>;
  defaultRecapExpanded?: Maybe<Scalars['Boolean']>;
  defaultRecapFeaturesExpanded?: Maybe<Scalars['Boolean']>;
  drawerWidth?: Maybe<Scalars['String']>;
  recapWidth?: Maybe<Scalars['Float']>;
  sidebarWidth?: Maybe<Scalars['String']>;
};

export type CpqDiscountLimits = {
  maxPercentage: Scalars['Float'];
  roleOverrides?: Maybe<Array<CpqRoleOverride>>;
};

export type CpqHierarchies = {
  lineItems: Scalars['String'];
  offers: Scalars['String'];
  orderLineItems?: Maybe<Scalars['String']>;
  orders?: Maybe<Scalars['String']>;
  sections: Scalars['String'];
  templates?: Maybe<Scalars['String']>;
};

export type CpqListSettings = {
  columns?: Maybe<Array<PrototypeContentType>>;
  enableExport?: Maybe<Scalars['Boolean']>;
  linkedByObjectSchemas?: Maybe<Array<Scalars['String']>>;
  systemColumns?: Maybe<Array<Scalars['String']>>;
};

export type CpqOfferNumberFormat = {
  includeYear: Scalars['Boolean'];
  prefix: Scalars['String'];
  sequenceLength: Scalars['Int'];
};

export type CpqRoleOverride = {
  maxPercentage: Scalars['Float'];
  role: Scalars['String'];
};

export type CpqSettings = {
  chainedConfiguration?: Maybe<CpqChainedConfiguration>;
  configurator?: Maybe<CpqConfiguratorSettings>;
  currency?: Maybe<Scalars['String']>;
  defaultTaxRate?: Maybe<Scalars['Float']>;
  defaultValidityDays?: Maybe<Scalars['Int']>;
  disableCompatiblePromptAfterFinalize?: Maybe<Scalars['Boolean']>;
  discountLimits?: Maybe<CpqDiscountLimits>;
  enable: Scalars['Boolean'];
  enableAddLinkedProduct?: Maybe<Scalars['Boolean']>;
  enableAddTemporaryFeature?: Maybe<Scalars['Boolean']>;
  enableAddTemporaryWarranty?: Maybe<Scalars['Boolean']>;
  enableAdditionalInfo?: Maybe<Scalars['Boolean']>;
  enableCart?: Maybe<Scalars['Boolean']>;
  enableFindSimilar?: Maybe<Scalars['Boolean']>;
  enableOrders?: Maybe<Scalars['Boolean']>;
  hierarchies: CpqHierarchies;
  lineItemColumns?: Maybe<Array<PrototypeContentType>>;
  lineItemPricingContentTypeGroups?: Maybe<Array<Scalars['String']>>;
  offerInfoContentTypeGroups?: Maybe<Array<Scalars['String']>>;
  offerList?: Maybe<CpqListSettings>;
  offerNumberFormat?: Maybe<CpqOfferNumberFormat>;
  orderList?: Maybe<CpqListSettings>;
  orderNumberFormat?: Maybe<CpqOfferNumberFormat>;
  orderWorkflowStatusContentType?: Maybe<PrototypeContentType>;
  readonlyStatuses?: Maybe<Array<Scalars['String']>>;
  support?: Maybe<CpqSupportSettings>;
  workflowStatusContentType?: Maybe<PrototypeContentType>;
};

export type CpqSupportFields = {
  request: PrototypeContentType;
  response: PrototypeContentType;
};

export type CpqSupportSettings = {
  lineItem: CpqSupportFields;
  offer: CpqSupportFields;
  requestStatus?: Maybe<Scalars['String']>;
};

export type CrmHierarchies = {
  accounts?: Maybe<Scalars['String']>;
  activities?: Maybe<Scalars['String']>;
  contacts?: Maybe<Scalars['String']>;
  leads?: Maybe<Scalars['String']>;
  opportunities?: Maybe<Scalars['String']>;
};

export type CrmLeadConversionMapping = {
  account?: Maybe<Array<CrmLeadFieldMapping>>;
  contact?: Maybe<Array<CrmLeadFieldMapping>>;
  offer?: Maybe<Array<CrmLeadFieldMapping>>;
  opportunity?: Maybe<Array<CrmLeadFieldMapping>>;
};

export type CrmLeadFieldMapping = {
  source: PrototypeContentType;
  target: PrototypeContentType;
};

export type CrmPipeline = {
  stages: Array<CrmPipelineStage>;
};

export type CrmPipelineStage = {
  code: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Int'];
  probability: Scalars['Float'];
};

export type CrmSettings = {
  enable: Scalars['Boolean'];
  hierarchies: CrmHierarchies;
  leadConversionMapping?: Maybe<CrmLeadConversionMapping>;
  pipeline: CrmPipeline;
  staleLeadDays?: Maybe<Scalars['Int']>;
  workflowStatusContentType?: Maybe<PrototypeContentType>;
};

export enum CtgStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  NotPublishable = 'NOT_PUBLISHABLE',
  Published = 'PUBLISHED',
  PublishedDraft = 'PUBLISHED_DRAFT'
}

export type CustomPage = {
  detailLayout: CustomPageLayout;
  detailLayoutFrom?: Maybe<Scalars['String']>;
  filter?: Maybe<CustomPageFilter>;
  fullBleed?: Maybe<Scalars['Boolean']>;
  hideInNavbar?: Maybe<Scalars['Boolean']>;
  hierarchyId: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  listLayout: CustomPageLayout;
  name: Scalars['String'];
  objectSchemaCode?: Maybe<Scalars['String']>;
  requiredRole?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type CustomPageButtonConfig = {
  color?: Maybe<Scalars['String']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  link: Scalars['String'];
  openInNewTab?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
};

export type CustomPageCardConfig = {
  bgColor?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  textColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CustomPageCardSort = {
  field: Scalars['String'];
  order?: Maybe<Scalars['String']>;
};

export type CustomPageColumn = {
  keepWidgetSlots?: Maybe<Scalars['Boolean']>;
  tabs?: Maybe<Array<CustomPageTab>>;
  widgets: Array<CustomPageWidget>;
  width?: Maybe<Scalars['String']>;
};

export type CustomPageDetailPage = {
  linkContentType?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type CustomPageFilter = {
  comparator: Scalars['String'];
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  value: Scalars['String'];
};

export type CustomPageImageStyle = {
  borderRadius?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  maxHeight?: Maybe<Scalars['String']>;
  maxWidth?: Maybe<Scalars['String']>;
  objectFit?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type CustomPageInfoItem = {
  contentTypeCode: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type CustomPageItemAction = {
  type: Scalars['String'];
};

export type CustomPageLayout = {
  columns: Array<CustomPageColumn>;
};

export type CustomPageMatrixAxisConfig = {
  depthRange?: Maybe<Array<Scalars['Int']>>;
  hierarchyId?: Maybe<Scalars['String']>;
  includeDisabled?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  labelProperty?: Maybe<Scalars['String']>;
};

export type CustomPageNumberFormat = {
  contentTypeCode: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  maximumFractionDigits?: Maybe<Scalars['Int']>;
  minimumFractionDigits?: Maybe<Scalars['Int']>;
  style?: Maybe<Scalars['String']>;
  useGrouping?: Maybe<Scalars['Boolean']>;
};

export type CustomPageTab = {
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  widgets: Array<CustomPageWidget>;
};

export type CustomPageWidget = {
  config?: Maybe<CustomPageWidgetConfig>;
  type: Scalars['String'];
};

export type CustomPageWidgetConfig = {
  actions?: Maybe<Array<ActionConfig>>;
  autoOpenSingleResult?: Maybe<Scalars['Boolean']>;
  backButtonLabel?: Maybe<Scalars['String']>;
  backLink?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  bgColor?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  buttons?: Maybe<Array<CustomPageButtonConfig>>;
  cardBgColor?: Maybe<Scalars['String']>;
  cardHeight?: Maybe<Scalars['String']>;
  cardTextColor?: Maybe<Scalars['String']>;
  cardVariant?: Maybe<Scalars['String']>;
  cardWidth?: Maybe<Scalars['String']>;
  cards?: Maybe<Array<CustomPageCardConfig>>;
  cellIcon?: Maybe<Scalars['String']>;
  channelCode?: Maybe<Scalars['String']>;
  channelCodes?: Maybe<Array<Scalars['String']>>;
  chartFilters?: Maybe<Array<ChartFilterConfig>>;
  chartType?: Maybe<Scalars['String']>;
  clickAction?: Maybe<ChartClickAction>;
  colorScheme?: Maybe<Scalars['String']>;
  columnGap?: Maybe<Scalars['String']>;
  columns?: Maybe<CustomPageMatrixAxisConfig>;
  columnsPerRow?: Maybe<Scalars['Int']>;
  contentSource?: Maybe<Scalars['String']>;
  contentTypeGroups?: Maybe<Array<Scalars['String']>>;
  countedFields?: Maybe<Array<PrototypeContentType>>;
  dense?: Maybe<Scalars['Boolean']>;
  depthRange?: Maybe<Array<Scalars['Int']>>;
  detailPage?: Maybe<CustomPageDetailPage>;
  dimensionContentType?: Maybe<PrototypeContentType>;
  direction?: Maybe<Scalars['String']>;
  displayContentTypes?: Maybe<Array<Scalars['String']>>;
  displayMode?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  exportEnabled?: Maybe<Scalars['Boolean']>;
  fileDisplay?: Maybe<Scalars['String']>;
  fullWidth?: Maybe<Scalars['Boolean']>;
  headingContentTypeCode?: Maybe<Scalars['String']>;
  hideBackButton?: Maybe<Scalars['Boolean']>;
  hideBottomBar?: Maybe<Scalars['Boolean']>;
  hideCode?: Maybe<Scalars['Boolean']>;
  hideContentTypeGroupHeaders?: Maybe<Scalars['Boolean']>;
  hideTopBar?: Maybe<Scalars['Boolean']>;
  hierarchyId?: Maybe<Scalars['String']>;
  hierarchyIds?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  imageContentType?: Maybe<Scalars['JSON']>;
  imageStyle?: Maybe<CustomPageImageStyle>;
  infoItems?: Maybe<Array<CustomPageInfoItem>>;
  itemAction?: Maybe<CustomPageItemAction>;
  languages?: Maybe<Array<Scalars['String']>>;
  legendPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  linkContentTypeCode?: Maybe<Scalars['String']>;
  linkDepth?: Maybe<Scalars['Int']>;
  linkPath?: Maybe<Array<Scalars['String']>>;
  linkedByHierarchyId?: Maybe<Scalars['String']>;
  loadMore?: Maybe<Scalars['Boolean']>;
  margin?: Maybe<CustomPageWidgetMargin>;
  maxHeight?: Maybe<Scalars['String']>;
  maxItems?: Maybe<Scalars['Int']>;
  measureContentType?: Maybe<PrototypeContentType>;
  mergeTitle?: Maybe<Scalars['Boolean']>;
  numberFormats?: Maybe<Array<CustomPageNumberFormat>>;
  overtextContentTypeCode?: Maybe<Scalars['String']>;
  padding?: Maybe<CustomPageWidgetPadding>;
  pageSize?: Maybe<Scalars['Int']>;
  periodDays?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
  rootNodeId?: Maybe<Scalars['String']>;
  rowGap?: Maybe<Scalars['String']>;
  rows?: Maybe<CustomPageMatrixAxisConfig>;
  showAddButton?: Maybe<Scalars['Boolean']>;
  showHeading?: Maybe<Scalars['Boolean']>;
  showIcon?: Maybe<Scalars['Boolean']>;
  showLabel?: Maybe<Scalars['Boolean']>;
  showNewButton?: Maybe<Scalars['Boolean']>;
  showSearch?: Maybe<Scalars['Boolean']>;
  showSeparator?: Maybe<Scalars['Boolean']>;
  showTitle?: Maybe<Scalars['Boolean']>;
  showViewAll?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<CustomPageCardSort>;
  sticky?: Maybe<Scalars['Boolean']>;
  stretchCards?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleContentTypeCode?: Maybe<Scalars['String']>;
  titleStyle?: Maybe<Scalars['String']>;
  typeContentType?: Maybe<Scalars['String']>;
  viewMode?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type CustomPageWidgetMargin = {
  b?: Maybe<Scalars['Float']>;
  l?: Maybe<Scalars['Float']>;
  r?: Maybe<Scalars['Float']>;
  t?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type CustomPageWidgetPadding = {
  b?: Maybe<Scalars['Float']>;
  l?: Maybe<Scalars['Float']>;
  r?: Maybe<Scalars['Float']>;
  t?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type DefaultPageUriConfig = {
  roleOverrides?: Maybe<Array<DefaultPageUriRule>>;
  uri: Scalars['String'];
};

export type DefaultPageUriRule = {
  role: Scalars['String'];
  uri: Scalars['String'];
};

/**
 * The three legacy fields keep ObjectSchemaMutationResponse's exact shape; everything added is
 * nullable so resolvers returning a bare {code,success,message} still typecheck.
 */
export type DeleteNodeResponse = {
  choiceRequired?: Maybe<Scalars['Boolean']>;
  code: Scalars['String'];
  /** The target node plus its whole subtree: removed whichever action is chosen. */
  deletedNodesTotal?: Maybe<Scalars['Int']>;
  linkedNodeGroups?: Maybe<Array<LinkedNodeGroup>>;
  linkedNodesTotal?: Maybe<Scalars['Int']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DiscountMpRoles = {
  max: Scalars['String'];
  min: Scalars['String'];
  role: Scalars['String'];
};

export type DynamicReadonly = {
  dynamicReadonlyRules?: Maybe<Array<DynamicReadonlyRule>>;
  message?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
};

export type DynamicReadonlyInput = {
  dynamicReadonlyRules?: InputMaybe<Array<DynamicReadonlyRuleInput>>;
  message?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Scalars['String']>;
};

export type DynamicReadonlyRule = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  option: Scalars['String'];
  value: Scalars['String'];
};

export type DynamicReadonlyRuleInput = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  kind?: InputMaybe<Scalars['String']>;
  option: Scalars['String'];
  value: Scalars['String'];
};

export type DynamicRegex = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  regex: Scalars['String'];
  value: Scalars['String'];
};

export type DynamicRegexInput = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  regex: Scalars['String'];
  value: Scalars['String'];
};

export type Edit = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  type: Scalars['String'];
  value: Scalars['NodeValue'];
};

export type Exporter = {
  couch: Couch;
  sql: Sql;
};

export type FavoriteRoles = {
  configurableProducts?: Maybe<Array<Scalars['String']>>;
  default?: Maybe<Array<Scalars['String']>>;
  nonConfigurableProducts?: Maybe<Array<Scalars['String']>>;
  productFamilies?: Maybe<Array<Scalars['String']>>;
};

export type FiammSettings = {
  balanceGoalsHierarchyId: Scalars['String'];
  pattuizioniHierarchyId?: Maybe<Scalars['String']>;
};

export type FieldSetting = {
  contentTypeCode: Scalars['String'];
  defaultValue?: Maybe<Scalars['String']>;
};

export type FieldsSetting = {
  baseProgramField: FieldSetting;
  biasedField: FieldSetting;
  c1Field: FieldSetting;
  c2Field: FieldSetting;
  c3Field: FieldSetting;
  cashDiscountField: FieldSetting;
  certificationStatusField: FieldSetting;
  conquestField: FieldSetting;
  cvaField: FieldSetting;
  dealerDiscountField: FieldSetting;
  denominationField: FieldSetting;
  descriptionField: FieldSetting;
  divisione: FieldSetting;
  extraValueSupportField: FieldSetting;
  familyField: FieldSetting;
  flagUseDN: FieldSetting;
  glBaseMachineField: FieldSetting;
  incentiveVolumeField: FieldSetting;
  installedDealerNetField: FieldSetting;
  itemsField: FieldSetting;
  lcField: FieldSetting;
  lineaSapField: FieldSetting;
  marca: FieldSetting;
  marcaField: FieldSetting;
  modelCodeField: FieldSetting;
  nodeTypeField: FieldSetting;
  notInstalledDealerNetField: FieldSetting;
  orderTypeField: FieldSetting;
  priceListField: FieldSetting;
  sapProductHierarchyField: FieldSetting;
  segmento: FieldSetting;
  selectionsField: FieldSetting;
  suffixField: FieldSetting;
  supplierField: FieldSetting;
  supplierNameField: FieldSetting;
  svField: FieldSetting;
  tipo: FieldSetting;
  typeField: FieldSetting;
};

export type Filters = {
  code: Scalars['String'];
  comparator: SearchFilterOperator;
  editable?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  value: Scalars['String'];
};

export type FiltersInput = {
  code: Scalars['String'];
  comparator: Scalars['String'];
  editable: Scalars['Boolean'];
  id: Scalars['String'];
  value: Scalars['String'];
};

export type GlCharacteristic = {
  code: Scalars['String'];
  label: Scalars['String'];
  options: Array<PrototypeGlDataValueGlCharacteristics>;
};

export type GlData = {
  glId: Scalars['String'];
  listPrice: Scalars['String'];
  transportCosts: Scalars['String'];
};

export type GlMediaCategoryMapping = {
  brochure: Scalars['String'];
  image: Scalars['String'];
  other: Scalars['String'];
  technical_drawing: Scalars['String'];
};

export type GlVersionItems = {
  prices: GlVersionItemsPrices;
  versionDate: Scalars['String'];
  versionId: Scalars['String'];
};

export type GlVersionItemsPrices = {
  dn?: Maybe<Scalars['Float']>;
};

export type GlVersionPrices = {
  rows: GlVersionPricesRows;
  versionDate: Scalars['String'];
  versionId: Scalars['String'];
};

export type GlVersionPricesRows = {
  dn?: Maybe<Scalars['Float']>;
  gp?: Maybe<Scalars['Float']>;
  lc?: Maybe<Scalars['Float']>;
  listino?: Maybe<Scalars['Float']>;
  mo?: Maybe<Scalars['Float']>;
  ms?: Maybe<Scalars['Float']>;
  tpa?: Maybe<Scalars['Float']>;
};

export type GlVersions = {
  glCode: Scalars['String'];
  items: Array<GlVersionsItemsData>;
  prices: GlVersionsPriceData;
};

export type GlVersionsItemsData = {
  itemId: Scalars['String'];
  version0?: Maybe<GlVersionItems>;
  version1?: Maybe<GlVersionItems>;
};

export type GlVersionsPriceData = {
  version0?: Maybe<GlVersionPrices>;
  version1?: Maybe<GlVersionPrices>;
};

export type GlobalSearchGroupLabel = {
  hierarchyId: Scalars['String'];
  label: Scalars['String'];
};

export type GlobalSearchMatchedIn = {
  key: Scalars['String'];
  lang?: Maybe<Scalars['String']>;
};

export type GlobalSearchResponse = {
  groups: Array<GlobalSearchResultGroup>;
};

export type GlobalSearchResultGroup = {
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  items: Array<GlobalSearchResultItem>;
  totalCount: Scalars['Int'];
};

export type GlobalSearchResultItem = {
  code: Scalars['String'];
  listName: Scalars['String'];
  matchedIn?: Maybe<Array<GlobalSearchMatchedIn>>;
  nodeId: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
};

export type GlobalSearchSettings = {
  groupLabels?: Maybe<Array<GlobalSearchGroupLabel>>;
  hierarchyIds: Array<Scalars['String']>;
  resultsPerGroup: Scalars['Int'];
  showPhasedOut?: Maybe<Scalars['Boolean']>;
};

export type GroupSetting = {
  contentTypeGroupCode: Scalars['String'];
};

export type GroupsSetting = {
  catSupportGroup: GroupSetting;
  cgtSupportGroup: GroupSetting;
  pricingGroup: GroupSetting;
  sapCharacteristicsGroup: GroupSetting;
};

export type HierarchiesSetting = {
  applicationCodeHierarchyId: Scalars['String'];
  attrezzatureFuoriListinoHierarchyId: Scalars['String'];
  backofficeHierarchyId?: Maybe<Scalars['String']>;
  cGTModelHierarchyId: Scalars['String'];
  cGTModelUsatoCompetitorHierarchyId: Scalars['String'];
  cadenzaInterventoHierarchyId: Scalars['String'];
  characteristicsCompatibilityRulesHierarchyId: Scalars['String'];
  commercialFamilyHierarchyId: Scalars['String'];
  digitalServiceHierarchyId: Scalars['String'];
  glExFlottaHierarchyId: Scalars['String'];
  glGenericHierarchyId: Scalars['String'];
  glHierarchyId: Scalars['String'];
  glUsatoCompetitorHierarchyId: Scalars['String'];
  linkedGlsCompatibilityRulesHierarchyId: Scalars['String'];
  longListsHierarchyId: Scalars['String'];
  marcheHierarchyId: Scalars['String'];
  mediaHierarchyId: Scalars['String'];
  mmDispoHierarchyId: Scalars['String'];
  plantHierarchyId?: Maybe<Scalars['String']>;
  priceListHierarchyId: Scalars['String'];
  productWarrantyHierarchyId: Scalars['String'];
  prototypeCompatibilitiesHierarchyId: Scalars['String'];
  ricambiHierarchyId?: Maybe<Scalars['String']>;
  sapProductCompetitorHierarchyId: Scalars['String'];
  sapProductHierarchyId: Scalars['String'];
  serviceContractHierarchyId: Scalars['String'];
  serviceModuleAMAListHierarchyId: Scalars['String'];
  serviceModuleHierarchyId: Scalars['String'];
  serviceModuleKitListHierarchyId: Scalars['String'];
  serviceModuleKmListHierarchyId: Scalars['String'];
  sezioniSchedeHierarchyId: Scalars['String'];
  shortListFamiliesExtraCharacteristicsHierarchyId: Scalars['String'];
  shortListFamilyHierarchyId: Scalars['String'];
  shortListsHierarchyId: Scalars['String'];
  supplierHierarchyId: Scalars['String'];
  systemSubSystemHierarchyId: Scalars['String'];
  tagliandiHierarchyId?: Maybe<Scalars['String']>;
  usagesCompatibilityRulesHierarchyId: Scalars['String'];
  warrantyCgtHierarchyId: Scalars['String'];
  warrantySupplierHierarchyId: Scalars['String'];
};

export type Hierarchy = {
  code: Scalars['String'];
  id: Scalars['String'];
  nodes: Array<HierarchyNode>;
  objectSchema?: Maybe<ObjectSchema>;
  readRoles?: Maybe<Array<Scalars['String']>>;
};


export type HierarchyNodesArgs = {
  filters?: InputMaybe<NodeFilter>;
  isInTranslation?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<Pagination>;
  transformNodes?: InputMaybe<Scalars['Boolean']>;
};

export type HierarchyHistoryEdge = {
  cursor: Scalars['String'];
  node: HierarchyHistoryNode;
};

export type HierarchyHistoryNode = {
  code: Scalars['String'];
  contents: Array<NodeContentO>;
  disabled: Scalars['Boolean'];
  eventId: Scalars['String'];
  eventName: Scalars['String'];
  parent: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  timestamp: Scalars['String'];
  user: Scalars['String'];
};

export type HierarchyHistoryResult = {
  edges: Array<HierarchyHistoryEdge>;
  objectSchema: ObjectSchema;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type HierarchyNode = {
  _rev?: Maybe<Scalars['String']>;
  assignedClient?: Maybe<AssignedNodeRef>;
  assignedDealership?: Maybe<AssignedNodeRef>;
  assignedMarket?: Maybe<AssignedNodeRef>;
  assignedOwner?: Maybe<AssignedNodeRef>;
  certificationStatus?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  contentTypeGroupStatus?: Maybe<Array<ContentTypeGroupStatus>>;
  contents?: Maybe<Array<NodeContentO>>;
  createdAt: Scalars['Float'];
  disabled?: Maybe<Scalars['Boolean']>;
  hasBeenCertified?: Maybe<Scalars['Boolean']>;
  hasChildren?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  linkedBy?: Maybe<Array<Maybe<LinkedBy>>>;
  listName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  nodePublished: CtgStatus;
  order?: Maybe<Scalars['String']>;
  parent: Scalars['String'];
  parentCode?: Maybe<Scalars['String']>;
  publishedContents?: Maybe<Array<NodeContentO>>;
  readRoles?: Maybe<Array<Scalars['String']>>;
  readUsers?: Maybe<Array<Scalars['String']>>;
  /** Lazily resolved: queries that do not select it pay no evaluation. */
  readonlyState?: Maybe<NodeReadonlyState>;
  totalChildren?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Float'];
  writeRoles?: Maybe<Array<Scalars['String']>>;
  writeUsers?: Maybe<Array<Scalars['String']>>;
};

export type HintoParams = {
  baseUrl: Scalars['String'];
  xApiKey: Scalars['String'];
};

export type ICompatibilityRuleInput = {
  contents: Array<NodeContent>;
  nodeId: Scalars['String'];
};

export enum ICompatibilityRulesTab {
  IncompatibleCharacteristics = 'IncompatibleCharacteristics',
  IncompatibleUsages = 'IncompatibleUsages',
  LinkedGls = 'LinkedGls'
}

export type IPrototypeCompatibilityInput = {
  contents: Array<NodeContent>;
  nodeId?: InputMaybe<Scalars['String']>;
};

export enum IPublishModelEvent {
  Delete = 'Delete',
  Update = 'Update'
}

export type InvalidGl = {
  code: Scalars['String'];
  id: Scalars['String'];
};

export type IsoCode = {
  approverRole?: Maybe<Scalars['String']>;
  isoCode: Scalars['String'];
  name: Scalars['String'];
  translatorRole?: Maybe<Scalars['String']>;
};

export enum ItemPositionType {
  Mandatory = 'mandatory',
  Merchandise = 'merchandise',
  Optional = 'optional'
}

export type JobFinishedInfo = {
  filename?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LaneInfoLink = {
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  installedPrice?: Maybe<Scalars['String']>;
  notInstalledPrice?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type Language = {
  defaultLanguage: Scalars['String'];
  languages: Array<IsoCode>;
};

export type LanguageInput = {
  approverRole?: InputMaybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  isoCode: Scalars['String'];
  name: Scalars['String'];
  translatorRole?: InputMaybe<Scalars['String']>;
};

/**
 * The listName of a node a link content points to, keyed by the linked hierarchy and the code the
 * link value carries. Only listNames that differ from the code are listed: a missing entry means
 * the code is the label.
 */
export type LinkListName = {
  code: Scalars['String'];
  hierarchyId: Scalars['String'];
  listName?: Maybe<Scalars['String']>;
};

export type LinkedBy = {
  code: Scalars['String'];
  hierarchyId: Scalars['String'];
  linkedNodes?: Maybe<Array<Maybe<LinkedBy>>>;
  listName?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
  order?: Maybe<Scalars['String']>;
};

/**
 * The readable nodes of one hierarchy that link a node: the first ones by label or listName (`items`)
 * and the count of them all (`totalCount`).
 */
export type LinkedByColumnGroup = {
  hierarchyCode?: Maybe<Scalars['String']>;
  hierarchyId: Scalars['String'];
  items: Array<LinkedByColumnRef>;
  totalCount: Scalars['Int'];
};

export type LinkedByColumnRef = {
  code: Scalars['String'];
  /** The value of the hierarchy's label field; null when none is configured or the value is empty. */
  label?: Maybe<Scalars['String']>;
  listName?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
};

/**
 * Asks `searchHierarchies` for the `linkedByColumns` of each node: its readable linkers grouped by
 * linking hierarchy. `hierarchyIds` narrows the linking hierarchies; absent or empty = all of them.
 * `labelFields` names, per linking hierarchy, the contents whose value labels its linkers: several
 * entries for one hierarchy are fallbacks, the first non-empty value wins.
 */
export type LinkedByColumnsInput = {
  hierarchyIds?: InputMaybe<Array<Scalars['String']>>;
  labelFields?: InputMaybe<Array<LinkedByLabelFieldInput>>;
};

export type LinkedByFilterOptionNode = {
  code: Scalars['String'];
  id: Scalars['String'];
  listName: Scalars['String'];
};

export type LinkedByHierarchyResult = {
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  objectSchemaCode: Scalars['String'];
  totalCount: Scalars['Int'];
};

/**
 * A content (first value, first language) that labels the linkers of a hierarchy, or their code
 * without `contentTypeGroup`/`contentType`. With `linkedHierarchyId` it is read on the node the linker
 * links in that hierarchy (e.g. the name of a line item's prototype) instead of on the linker.
 */
export type LinkedByLabelFieldInput = {
  contentType?: InputMaybe<Scalars['String']>;
  contentTypeGroup?: InputMaybe<Scalars['String']>;
  hierarchyId: Scalars['String'];
  linkedHierarchyId?: InputMaybe<Scalars['String']>;
};

export type LinkedModelGlInfo = {
  c1: Scalars['String'];
  c2: Scalars['String'];
  c3: Scalars['String'];
  deltaPrezzoStandard: Scalars['String'];
  dn: Scalars['String'];
  dnCashD: Scalars['String'];
  gp: Scalars['String'];
  id: Scalars['String'];
  lc: Scalars['String'];
  lcPerc: Scalars['String'];
  listPrice: Scalars['String'];
  listinoForn: Scalars['Boolean'];
  markup: Scalars['String'];
  mo: Scalars['String'];
  modelName: Scalars['String'];
  ms: Scalars['String'];
  /** Codes of the open prototypes of the model that force their own list price for this GL. */
  prototypesForcingListPrice: Array<Scalars['String']>;
  /** Codes of the open prototypes of the model that force their own transport charge for this GL. */
  prototypesForcingTransportCosts: Array<Scalars['String']>;
  status: Scalars['String'];
  tpa: Scalars['String'];
  transportCosts: Scalars['String'];
};

/** The caller's answer when the schema strategy is `ask`. It can never be `ask` itself. */
export enum LinkedNodeDeleteAction {
  Cascade = 'cascade',
  Unlink = 'unlink'
}

/** What happens to the nodes linking to a deleted node, configured per object schema. */
export enum LinkedNodeDeleteStrategy {
  Ask = 'ask',
  Cascade = 'cascade',
  Unlink = 'unlink'
}

/** `items` is capped by the server; `totalCount` is always the true number in that hierarchy. */
export type LinkedNodeGroup = {
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  items: Array<LinkedNodeRef>;
  objectSchemaCode: Scalars['String'];
  totalCount: Scalars['Int'];
};

export type LinkedNodeRef = {
  code: Scalars['String'];
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  /** Codes of the link fields the unlink will empty on this node. */
  linkedByFields?: Maybe<Array<Scalars['String']>>;
  listName?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
};

export type LinkedNodesForDeleteResult = {
  groups: Array<LinkedNodeGroup>;
  total: Scalars['Int'];
};

export type MmDispoValidity = {
  errors: Array<PrototypeMmDispoError>;
  prototypeCode: Scalars['String'];
  prototypeId: Scalars['String'];
  values: Array<PrototypeMmDispoValue>;
};

export type MandatoryForSaveCondition = {
  comparator?: Maybe<Scalars['String']>;
  isMandatory?: Maybe<Scalars['Boolean']>;
  option?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MandatoryForSaveConditionInput = {
  comparator?: InputMaybe<Scalars['String']>;
  isMandatory: Scalars['Boolean'];
  option?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum MasterPropagationOutcome {
  Failed = 'FAILED',
  Updated = 'UPDATED',
  /** the master publishes the derived version, but its configurator could not be exported */
  UpdatedExportFailed = 'UPDATED_EXPORT_FAILED',
  UpdatedNotExported = 'UPDATED_NOT_EXPORTED'
}

export type MasterPropagationResult = {
  action: PendingMasterAction;
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  outcome: MasterPropagationOutcome;
  schedaId: Scalars['String'];
};

export type MediaSettings = {
  enable?: Maybe<Scalars['Boolean']>;
  hierarchyId: Scalars['String'];
};

export type Metadata = {
  createdAt?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['BigInt']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type MicrosoftGraphParams = {
  authUrl: Scalars['String'];
  baseUrl: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  scope: Scalars['String'];
};

export type MisalignedGlData = {
  code: Scalars['String'];
  hierarchyId: Scalars['String'];
  items: Array<MisalignedGlDataItem>;
  nodeId: Scalars['String'];
};

export type MisalignedGlDataItem = {
  code: Scalars['String'];
  replacedBy: Scalars['String'];
};

export enum ModelGlStatus {
  Active = 'Active',
  Certificating = 'Certificating',
  CertificationError = 'CertificationError',
  CertificationSuccess = 'CertificationSuccess',
  Error = 'Error',
  MisalignedPrice = 'MisalignedPrice',
  Replaced = 'Replaced',
  StdPriceDelta = 'StdPriceDelta',
  ToCertificate = 'ToCertificate',
  Trasversal = 'Trasversal'
}

export type ModelGlStatusData = {
  data?: Maybe<Array<Scalars['String']>>;
  items?: Maybe<Array<MisalignedGlDataItem>>;
  status: ModelGlStatus;
};

export type ModelGlStatuses = {
  glCode: Scalars['String'];
  glHierarchyId: Scalars['String'];
  glId: Scalars['String'];
  hasCompatiblePriceLists?: Maybe<Scalars['Boolean']>;
  statuses: Array<ModelGlStatusData>;
};

export type Mutation = {
  _empty?: Maybe<Scalars['String']>;
  addContentType?: Maybe<ObjectSchemaMutationResponse>;
  addContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  addLanguage?: Maybe<ObjectSchemaMutationResponse>;
  alignLongLists?: Maybe<ObjectSchemaMutationResponse>;
  alignLonglistsSections?: Maybe<ObjectSchemaMutationResponse>;
  alignMismatchGl?: Maybe<ObjectSchemaMutationResponse>;
  alignModelGls?: Maybe<AlignModelGlsResponse>;
  approveContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  approveLongList: PublishResponse;
  approveNodeTranslations?: Maybe<ApproveNodeTranslationsResponse>;
  certificateNode?: Maybe<CertificationResponse>;
  certificatePrototype?: Maybe<CertificationResponse>;
  changeGlPriceList?: Maybe<ObjectSchemaMutationResponse>;
  changeLongListCommercialFamily?: Maybe<ObjectSchemaMutationResponse>;
  changeNodesOrder?: Maybe<ObjectSchemaMutationResponse>;
  contentTranslationApproval?: Maybe<Scalars['Boolean']>;
  createHierarchy?: Maybe<ObjectSchemaMutationResponse>;
  createLongList?: Maybe<ObjectSchemaMutationResponse>;
  createNode?: Maybe<ObjectSchemaMutationResponse>;
  /** Notification-definition CRUD (admin-only, PIM_SUPERADMIN; company-scoped). */
  createNotificationDefinition: NotificationDefinition;
  createObjectSchema?: Maybe<ObjectSchemaMutationResponse>;
  createPrototype?: Maybe<ObjectSchemaMutationResponse>;
  createShortList?: Maybe<ObjectSchemaMutationResponse>;
  deleteContentType?: Maybe<ObjectSchemaMutationResponse>;
  deleteContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  deleteHierarchy?: Maybe<DeleteNodeResponse>;
  deleteLanguage?: Maybe<ObjectSchemaMutationResponse>;
  deleteNode?: Maybe<DeleteNodeResponse>;
  deleteNotificationDefinition: Scalars['Boolean'];
  deleteObjectSchema?: Maybe<ObjectSchemaMutationResponse>;
  duplicateHierarchy?: Maybe<ObjectSchemaMutationResponse>;
  duplicateObjectSchema?: Maybe<ObjectSchemaMutationResponse>;
  duplicatePrototype?: Maybe<ObjectSchemaMutationResponse>;
  exportXlsx?: Maybe<Scalars['String']>;
  markAllNotificationsRead: Scalars['Boolean'];
  markNotificationRead: Scalars['Boolean'];
  migrateSidelHierarchyData?: Maybe<ObjectSchemaMutationResponse>;
  migrateSidelProductsData?: Maybe<ObjectSchemaMutationResponse>;
  publish?: Maybe<ObjectSchemaMutationResponse>;
  publishHierarchies?: Maybe<ObjectSchemaMutationResponse>;
  publishLongList: PublishResponse;
  publishModel?: Maybe<CertificationResponse>;
  publishWithRelated?: Maybe<PublishWithRelatedResponse>;
  reorderContentType?: Maybe<ObjectSchemaMutationResponse>;
  reorderContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  replaceItem?: Maybe<ObjectSchemaMutationResponse>;
  saveCompatibilityRules?: Maybe<ObjectSchemaMutationResponse>;
  savePrototypeCompatibility?: Maybe<ObjectSchemaMutationResponse>;
  savePrototypeGlForcedValues?: Maybe<ObjectSchemaMutationResponse>;
  saveShortListPdfColumns?: Maybe<ObjectSchemaMutationResponse>;
  saveTrasversalGls?: Maybe<ObjectSchemaMutationResponse>;
  /** Makes exactly the given schede link the scheda through their matching_long_lists. */
  setMasterLongLists?: Maybe<ObjectSchemaMutationResponse>;
  toggleDisabled?: Maybe<ObjectSchemaMutationResponse>;
  toggleFavorite: ToggleFavoriteResponse;
  unpublish?: Maybe<ObjectSchemaMutationResponse>;
  unpublishLongList: PublishResponse;
  updateBulkNodesContents?: Maybe<ObjectSchemaMutationResponse>;
  updateCertificationStatus?: Maybe<ObjectSchemaMutationResponse>;
  updateContentType?: Maybe<ObjectSchemaMutationResponse>;
  updateContentTypeCode?: Maybe<ObjectSchemaMutationResponse>;
  updateContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  updateContentTypeGroupCode?: Maybe<ObjectSchemaMutationResponse>;
  updateHierarchy?: Maybe<ObjectSchemaMutationResponse>;
  updateLanguage?: Maybe<ObjectSchemaMutationResponse>;
  updateListName?: Maybe<Scalars['Boolean']>;
  updateNode?: Maybe<ObjectSchemaMutationResponse>;
  updateNodeContent?: Maybe<ObjectSchemaMutationResponse>;
  updateNodeParent?: Maybe<ObjectSchemaMutationResponse>;
  updateNotificationDefinition: NotificationDefinition;
  updateObjectSchema?: Maybe<ObjectSchemaMutationResponse>;
  updatePermissions?: Maybe<UpdatePermissionsResponse>;
  updatePrototype?: Maybe<PrototypeUpdateMutationResponse>;
  updateShortList?: Maybe<ObjectSchemaMutationResponse>;
  updateTranslationStatistics?: Maybe<ObjectSchemaMutationResponse>;
};


export type MutationAddContentTypeArgs = {
  aggregateId: Scalars['String'];
  contentType: ContentTypeInput;
  groupCode: Scalars['String'];
};


export type MutationAddContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  contentTypeGroup: ContentTypeGroupI;
};


export type MutationAddLanguageArgs = {
  language: LanguageInput;
};


export type MutationAlignLongListsArgs = {
  longListIds: Array<Scalars['String']>;
  prototypeId: Scalars['String'];
};


export type MutationAlignLonglistsSectionsArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
  notes: Scalars['String'];
  sectionNodeId: Scalars['String'];
};


export type MutationAlignMismatchGlArgs = {
  modelId: Scalars['String'];
};


export type MutationAlignModelGlsArgs = {
  misalignedGlsIds: Array<Scalars['String']>;
  modelId: Scalars['String'];
};


export type MutationApproveContentTypeGroupArgs = {
  contentTypeGroup?: InputMaybe<Scalars['String']>;
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationApproveLongListArgs = {
  aggregateId: Scalars['String'];
  node: Scalars['String'];
  prototypeId: Scalars['String'];
};


export type MutationApproveNodeTranslationsArgs = {
  hierarchyId: Scalars['String'];
  languageIsoCode: Scalars['String'];
  nodeIds: Array<Scalars['String']>;
};


export type MutationCertificateNodeArgs = {
  aggregateId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationCertificatePrototypeArgs = {
  cgtModelVariables: CgtModelVariables;
  prototypeId: Scalars['String'];
};


export type MutationChangeGlPriceListArgs = {
  disabledPriceListId?: InputMaybe<Scalars['String']>;
  glId: Scalars['String'];
  modelId: Scalars['String'];
  priceListId?: InputMaybe<Scalars['String']>;
  priceListIdZMAB?: InputMaybe<Scalars['String']>;
};


export type MutationChangeLongListCommercialFamilyArgs = {
  familyId: Scalars['String'];
  longListId: Scalars['String'];
  longListParent: Scalars['String'];
};


export type MutationChangeNodesOrderArgs = {
  hierarchyId: Scalars['String'];
  nodeOrder: Array<OrderNode>;
  parentId: Scalars['String'];
};


export type MutationContentTranslationApprovalArgs = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  hierarchyId: Scalars['String'];
  languageIsoCode: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationCreateHierarchyArgs = {
  code: Scalars['String'];
  objectSchema: Scalars['String'];
};


export type MutationCreateLongListArgs = {
  aggregateId: Scalars['String'];
  commercialFamilyId: Scalars['String'];
  commercialFamilyParentId: Scalars['String'];
  prototypeId: Scalars['String'];
};


export type MutationCreateNodeArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
  parent: Scalars['String'];
};


export type MutationCreateNotificationDefinitionArgs = {
  input: NotificationDefinitionInput;
};


export type MutationCreateObjectSchemaArgs = {
  assignmentPropagation?: InputMaybe<AssignmentPropagationInput>;
  automaticParentCreation: Scalars['Boolean'];
  bulkPublish: Scalars['Boolean'];
  code: Scalars['String'];
  codeCreationExpression: Scalars['String'];
  codeLabel: Scalars['String'];
  dataTable?: InputMaybe<Scalars['Boolean']>;
  disableDelete: Scalars['Boolean'];
  disableDeleteHierarchy: Scalars['Boolean'];
  disableEditCode: Scalars['Boolean'];
  enableOwner: Scalars['Boolean'];
  enablePublish: Scalars['Boolean'];
  hideChangeParent?: InputMaybe<Scalars['Boolean']>;
  hideDisableToggle?: InputMaybe<Scalars['Boolean']>;
  hideDisableToggleDepths?: InputMaybe<Array<Scalars['Int']>>;
  linkedNodeDeleteStrategy?: InputMaybe<LinkedNodeDeleteStrategy>;
  listName: Scalars['String'];
  nodeReadonly?: InputMaybe<NodeReadonlyRuleInput>;
  showListNameInEdit: Scalars['Boolean'];
  showPublishInfo: Scalars['Boolean'];
};


export type MutationCreatePrototypeArgs = {
  modelName: Scalars['String'];
  prototypeCode: Scalars['String'];
};


export type MutationCreateShortListArgs = {
  details: ShortListDetails;
};


export type MutationDeleteContentTypeArgs = {
  aggregateId: Scalars['String'];
  contentTypeCode: Scalars['String'];
  groupCode: Scalars['String'];
};


export type MutationDeleteContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
};


export type MutationDeleteHierarchyArgs = {
  aggregateId: Scalars['String'];
  linkedAction?: InputMaybe<LinkedNodeDeleteAction>;
};


export type MutationDeleteLanguageArgs = {
  isoCode: Scalars['String'];
};


export type MutationDeleteNodeArgs = {
  aggregateId: Scalars['String'];
  linkedAction?: InputMaybe<LinkedNodeDeleteAction>;
  node: Scalars['String'];
};


export type MutationDeleteNotificationDefinitionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteObjectSchemaArgs = {
  aggregateId: Scalars['String'];
};


export type MutationDuplicateHierarchyArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
  market?: InputMaybe<Scalars['String']>;
};


export type MutationDuplicateObjectSchemaArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
};


export type MutationDuplicatePrototypeArgs = {
  contents?: InputMaybe<Array<NodeContent>>;
  modelName: Scalars['String'];
  prototypeCode: Scalars['String'];
  prototypeId: Scalars['String'];
};


export type MutationExportXlsxArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  nodeId?: InputMaybe<Scalars['String']>;
  sort: Array<Sort>;
  visibleFields?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['ID'];
};


export type MutationPublishArgs = {
  contentTypeGroups: Array<Scalars['String']>;
  hierarchy: Scalars['String'];
  node: Scalars['String'];
};


export type MutationPublishHierarchiesArgs = {
  hierarchies?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationPublishLongListArgs = {
  aggregateId: Scalars['String'];
  cgtModelId: Scalars['String'];
  nodeId: Scalars['String'];
  prototypeId: Scalars['String'];
  publishedDocumentId: Scalars['String'];
};


export type MutationPublishModelArgs = {
  aggregateId: Scalars['String'];
  event: IPublishModelEvent;
  nodeId: Scalars['String'];
};


export type MutationPublishWithRelatedArgs = {
  targets: Array<PublishTarget>;
};


export type MutationReorderContentTypeArgs = {
  aggregateId: Scalars['String'];
  groupCode: Scalars['String'];
  order: Array<Scalars['String']>;
};


export type MutationReorderContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  order: Array<Scalars['String']>;
};


export type MutationReplaceItemArgs = {
  newItemCode: Scalars['String'];
  nodeCode: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationSaveCompatibilityRulesArgs = {
  aggregateId: Scalars['String'];
  prototypeId: Scalars['String'];
  rules: Array<ICompatibilityRuleInput>;
};


export type MutationSavePrototypeCompatibilityArgs = {
  rules: Array<IPrototypeCompatibilityInput>;
};


export type MutationSavePrototypeGlForcedValuesArgs = {
  modelId: Scalars['String'];
  prototypes: Array<PrototypeGlForcedValues>;
};


export type MutationSaveShortListPdfColumnsArgs = {
  columns: Array<ShortListPdfColumnInput>;
  familyNodeId: Scalars['String'];
  headers: Array<ShortListEditableHeadersInput>;
  shortListNodeId: Scalars['String'];
};


export type MutationSaveTrasversalGlsArgs = {
  glData: Array<GlData>;
  modelIds: Array<Scalars['String']>;
};


export type MutationSetMasterLongListsArgs = {
  longListId: Scalars['String'];
  masterLongListIds: Array<Scalars['String']>;
};


export type MutationToggleDisabledArgs = {
  aggregateId: Scalars['String'];
  node: Scalars['String'];
};


export type MutationToggleFavoriteArgs = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationUnpublishArgs = {
  hierarchy: Scalars['String'];
  node: Scalars['String'];
};


export type MutationUnpublishLongListArgs = {
  nodeId: Scalars['String'];
  prototypeId: Scalars['String'];
  publishedDocumentId: Scalars['String'];
};


export type MutationUpdateBulkNodesContentsArgs = {
  aggregateId: Scalars['String'];
  nodes: Array<BulkNodes>;
};


export type MutationUpdateCertificationStatusArgs = {
  aggregateId: Scalars['String'];
  contents: Array<NodeContent>;
  documentVersion?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
};


export type MutationUpdateContentTypeArgs = {
  aggregateId: Scalars['String'];
  groupCode: Scalars['String'];
  updateContentTypeInput: ContentTypeInput;
};


export type MutationUpdateContentTypeCodeArgs = {
  aggregateId: Scalars['String'];
  groupCode: Scalars['String'];
  newCode: Scalars['String'];
  oldCode: Scalars['String'];
};


export type MutationUpdateContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  updateContentTypeGroupInput: UpdateContentTypeGroupInput;
};


export type MutationUpdateContentTypeGroupCodeArgs = {
  aggregateId: Scalars['String'];
  newCode: Scalars['String'];
  oldCode: Scalars['String'];
};


export type MutationUpdateHierarchyArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
  objectSchema: Scalars['String'];
};


export type MutationUpdateLanguageArgs = {
  language: LanguageInput;
  oldIsoCode: Scalars['String'];
};


export type MutationUpdateListNameArgs = {
  listName: Scalars['String'];
  objectSchema: Scalars['String'];
};


export type MutationUpdateNodeArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
  node: Scalars['String'];
  parent?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateNodeContentArgs = {
  aggregateId: Scalars['String'];
  contents: Array<NodeContent>;
  isCreate?: InputMaybe<Scalars['Boolean']>;
  node: Scalars['String'];
  parent?: InputMaybe<Scalars['String']>;
  skipTranslation: Scalars['Boolean'];
};


export type MutationUpdateNodeParentArgs = {
  aggregateId: Scalars['String'];
  node: Scalars['String'];
  parent: Scalars['String'];
};


export type MutationUpdateNotificationDefinitionArgs = {
  id: Scalars['ID'];
  input: NotificationDefinitionInput;
};


export type MutationUpdateObjectSchemaArgs = {
  aggregateId: Scalars['String'];
  assignmentPropagation?: InputMaybe<AssignmentPropagationInput>;
  automaticParentCreation: Scalars['Boolean'];
  bulkPublish: Scalars['Boolean'];
  code: Scalars['String'];
  codeCreationExpression: Scalars['String'];
  codeLabel: Scalars['String'];
  dataTable?: InputMaybe<Scalars['Boolean']>;
  disableDelete: Scalars['Boolean'];
  disableDeleteHierarchy: Scalars['Boolean'];
  disableEditCode: Scalars['Boolean'];
  enableOwner: Scalars['Boolean'];
  enablePublish: Scalars['Boolean'];
  hideChangeParent?: InputMaybe<Scalars['Boolean']>;
  hideDisableToggle?: InputMaybe<Scalars['Boolean']>;
  hideDisableToggleDepths?: InputMaybe<Array<Scalars['Int']>>;
  linkedNodeDeleteStrategy?: InputMaybe<LinkedNodeDeleteStrategy>;
  listName: Scalars['String'];
  nodeReadonly?: InputMaybe<NodeReadonlyRuleInput>;
  showListNameInEdit: Scalars['Boolean'];
  showPublishInfo: Scalars['Boolean'];
};


export type MutationUpdatePermissionsArgs = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
  readRoles: Array<Scalars['String']>;
  readUsers: Array<Scalars['String']>;
  writeRoles: Array<Scalars['String']>;
  writeUsers: Array<Scalars['String']>;
};


export type MutationUpdatePrototypeArgs = {
  contents: Array<NodeContent>;
  node: Scalars['String'];
  skipTranslation: Scalars['Boolean'];
};


export type MutationUpdateShortListArgs = {
  columns?: InputMaybe<Scalars['String']>;
  familyNodeId?: InputMaybe<Scalars['String']>;
  legend: Array<ShortListLegendItemInput>;
  prototypesNodesIds: Array<Scalars['String']>;
  shortListFamilyNodeId: Scalars['String'];
  shortListNodeId: Scalars['String'];
};


export type MutationUpdateTranslationStatisticsArgs = {
  keptAsReceivedCount: Scalars['Int'];
  modifiedCount: Scalars['Int'];
};

export type NameObject = {
  languageIsoCode: Scalars['String'];
  value: Scalars['String'];
};

export type NameObjectI = {
  languageIsoCode: Scalars['String'];
  value: Scalars['String'];
};

export type NodeAtDate = {
  code: Scalars['String'];
  contents: Array<NodeContentO>;
  createdAt: Scalars['Float'];
  /** The nodes from the root down to this one, both included. */
  depth: Scalars['Int'];
  disabled: Scalars['Boolean'];
  hierarchy: Scalars['String'];
  /** The code the hierarchy had at the date. */
  hierarchyCode: Scalars['String'];
  id: Scalars['String'];
  listName: Scalars['String'];
  parent: Scalars['String'];
  parentCode: Scalars['String'];
  updatedAt: Scalars['Float'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type NodeAtDateDiff = {
  contentChanges: Array<NodeContentChange>;
  fieldChanges: Array<NodeFieldChange>;
  from: NodeAtDateResult;
  to: NodeAtDateResult;
};

export type NodeAtDateResult = {
  date: Scalars['Float'];
  linkedNodes: Array<NodeAtDate>;
  node?: Maybe<NodeAtDate>;
  /** The object schema of the hierarchy of the node at the date. */
  objectSchema?: Maybe<ObjectSchema>;
};

export type NodeContent = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  hierarchy?: InputMaybe<Scalars['String']>;
  inherited?: InputMaybe<Scalars['Boolean']>;
  repeatable: Scalars['Boolean'];
  type: Scalars['String'];
  value: Array<NodeContentValue>;
};

export type NodeContentChange = {
  after?: Maybe<NodeContentO>;
  before?: Maybe<NodeContentO>;
  change: NodeContentChangeKind;
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
};

export enum NodeContentChangeKind {
  Added = 'ADDED',
  Changed = 'CHANGED',
  Removed = 'REMOVED'
}

export type NodeContentFilter = {
  contentType?: InputMaybe<Scalars['String']>;
  contentTypeGroup?: InputMaybe<Scalars['String']>;
  strictCheck?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type NodeContentO = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  inherited: Scalars['Boolean'];
  repeatable?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  value?: Maybe<Array<NodeContentValueO>>;
  valueDecryptionFailed?: Maybe<Scalars['Boolean']>;
};

export type NodeContentValue = {
  approvedValue?: InputMaybe<Array<Scalars['NodeValue']>>;
  autoGenerated?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  languageIsoCode: Scalars['String'];
  measure?: InputMaybe<Scalars['String']>;
  translate?: InputMaybe<Scalars['Boolean']>;
  translating?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['NodeValue']>;
};

export type NodeContentValueO = {
  approvedValue?: Maybe<Array<Maybe<Scalars['NodeValue']>>>;
  autoGenerated?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  languageIsoCode: Scalars['String'];
  measure?: Maybe<Scalars['String']>;
  translate?: Maybe<Scalars['Boolean']>;
  translating?: Maybe<Scalars['Boolean']>;
  value: Array<Maybe<Scalars['NodeValue']>>;
};

export type NodeFieldChange = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  /** One of exists, code, parent, listName, disabled. */
  field: Scalars['String'];
};

export type NodeFilter = {
  code?: InputMaybe<Scalars['String']>;
  contentFilters?: InputMaybe<Array<NodeContentFilter>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  parent?: InputMaybe<Scalars['String']>;
};

/** A node is read-only when `expression` evaluates to exactly `true` against its saved state. */
export type NodeReadonlyRule = {
  /** "contentTypeGroupCode.contentTypeCode" entries still editable on a locked node. */
  excludedFields?: Maybe<Array<Scalars['String']>>;
  expression: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type NodeReadonlyRuleInput = {
  excludedFields?: InputMaybe<Array<Scalars['String']>>;
  expression: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
};

export type NodeReadonlyState = {
  /** The rule failed to evaluate: the node is left writable (fail open). */
  error?: Maybe<Scalars['String']>;
  excludedFields: Array<Scalars['String']>;
  locked: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type NodeResult = {
  count: Scalars['Int'];
  edges: Array<SearchNodeEdge>;
  pageInfo: PageInfo;
};

export type NodeUpdate = {
  author?: Maybe<Scalars['String']>;
  edits: Array<Edit>;
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
  timestamp: Scalars['Float'];
  type: NodeUpdateType;
};

export enum NodeUpdateType {
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type Notification = {
  createdAt: Scalars['String'];
  deepLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  read: Scalars['Boolean'];
  title: Scalars['String'];
  type?: Maybe<NotificationType>;
};

/**
 * A notification definition (FR-MSC-02 trigger). Each string field below the identity columns holds
 * a JSONata source expression evaluated per matching event, in the context { event, node }.
 * Admin-only (PIM_SUPERADMIN); company-scoped.
 */
export type NotificationDefinition = {
  aggregateId?: Maybe<Scalars['String']>;
  companyCode: Scalars['String'];
  condition?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notificationLink?: Maybe<Scalars['String']>;
  notificationMessage?: Maybe<Scalars['String']>;
  notificationTitle?: Maybe<Scalars['String']>;
  notificationType?: Maybe<Scalars['String']>;
  sendEmail?: Maybe<Scalars['String']>;
  targetDealerships?: Maybe<Scalars['String']>;
  targetRoles?: Maybe<Scalars['String']>;
  targetUsers?: Maybe<Scalars['String']>;
};

export type NotificationDefinitionInput = {
  aggregateId?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  notificationLink?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notificationTitle?: InputMaybe<Scalars['String']>;
  notificationType?: InputMaybe<Scalars['String']>;
  sendEmail?: InputMaybe<Scalars['String']>;
  targetDealerships?: InputMaybe<Scalars['String']>;
  targetRoles?: InputMaybe<Scalars['String']>;
  targetUsers?: InputMaybe<Scalars['String']>;
};

/** Read-state change pushed to the reading user's other open tabs/devices. */
export type NotificationReadEvent = {
  notificationIds: Array<Scalars['ID']>;
};

/**
 * Closed set of notification kinds; the UI maps each one to an icon.
 * Extend here (and in notifications/types.ts NOTIFICATION_TYPES) when new kinds are added.
 */
export enum NotificationType {
  Error = 'error',
  Info = 'info',
  Success = 'success'
}

export type ObjectSchema = {
  assignmentPropagation?: Maybe<AssignmentPropagation>;
  automaticParentCreation?: Maybe<Scalars['Boolean']>;
  bulkPublish?: Maybe<Scalars['Boolean']>;
  code: Scalars['String'];
  codeCreationExpression?: Maybe<Scalars['String']>;
  codeLabel?: Maybe<Scalars['String']>;
  contentTypeGroups?: Maybe<Array<ContentTypeGroup>>;
  dataTable?: Maybe<Scalars['Boolean']>;
  disableDelete?: Maybe<Scalars['Boolean']>;
  disableDeleteHierarchy?: Maybe<Scalars['Boolean']>;
  disableEditCode?: Maybe<Scalars['Boolean']>;
  enableOwner?: Maybe<Scalars['Boolean']>;
  enablePublish?: Maybe<Scalars['Boolean']>;
  hideChangeParent?: Maybe<Scalars['Boolean']>;
  hideDisableToggle?: Maybe<Scalars['Boolean']>;
  hideDisableToggleDepths?: Maybe<Array<Scalars['Int']>>;
  id: Scalars['String'];
  isReferenced: Scalars['Boolean'];
  linkedNodeDeleteStrategy?: Maybe<LinkedNodeDeleteStrategy>;
  listName?: Maybe<Scalars['String']>;
  /** `<group>-<code>` of every content type its module owns, on the same terms. */
  managedContentTypes?: Maybe<Array<Scalars['String']>>;
  /**
   * Codes of the content type groups this schema's module owns. Empty unless that module opted in
   * with `managed: true`; computed from the shipped definition, never stored.
   *
   * Nullable so a query that does not ask for them still describes a whole ObjectSchema: absent
   * reads the same as empty, which is "nothing is locked".
   */
  managedGroups?: Maybe<Array<Scalars['String']>>;
  nodeReadonly?: Maybe<NodeReadonlyRule>;
  showListNameInEdit?: Maybe<Scalars['Boolean']>;
  showPublishInfo?: Maybe<Scalars['Boolean']>;
};

export type ObjectSchemaMutationResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ObjectSchemasMetadata = {
  shortListFamilyId?: InputMaybe<Scalars['String']>;
};

export type ObjectSchemasSetting = {
  cgtModelHierarchyObjectSchemaId: Scalars['String'];
  glHierarchyObjectSchemaId: Scalars['String'];
  longListsHierarchyObjectSchemaId: Scalars['String'];
  prototypeHierarchyObjectSchemaId: Scalars['String'];
  sapProductHierarchyObjectSchemaId: Scalars['String'];
  shortListFamiliesExtraCharacteristicsObjectSchemaId: Scalars['String'];
};

export type OptionFiltersSettings = {
  defaultFilterMode?: Maybe<Scalars['String']>;
  enable?: Maybe<Scalars['Boolean']>;
  explorationMode?: Maybe<Scalars['String']>;
  hideUnknownProducts?: Maybe<Scalars['Boolean']>;
  includeNonConfigurable?: Maybe<Scalars['Boolean']>;
  maxBasisAgeDays?: Maybe<Scalars['Int']>;
};

export type OptionValue = {
  languageIsoCode: Scalars['String'];
  value: Scalars['String'];
};

export type OptionValueInput = {
  languageIsoCode: Scalars['String'];
  value: Scalars['String'];
};

export type OptionWarning = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  warningMessage: Scalars['String'];
};

export type OptionsSource = {
  contentTypeCode?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
};

export type OptionsSourceInput = {
  contentTypeCode?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
};

export type OrderNode = {
  nodeId: Scalars['String'];
  order: Scalars['Int'];
};

export type OriginNode = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type Pagination = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type PathsSetting = {
  accessories: Scalars['String'];
  baseMachine: Scalars['String'];
  itemsValue: Scalars['String'];
  priceListValue: Scalars['String'];
  primaryPriceListValue: Scalars['String'];
  sapProductHierarchyValue: Scalars['String'];
  secondaryPriceListValue: Scalars['String'];
};

export enum PendingMasterAction {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type PendingMasterLongList = {
  action: PendingMasterAction;
  code: Scalars['String'];
  schedaId: Scalars['String'];
};

export type PhaseOutSettings = {
  soonLabelDays?: Maybe<Scalars['Int']>;
  soonLabelEnabled?: Maybe<Scalars['Boolean']>;
};

export type PimPricingHierarchies = {
  priceLists: Scalars['String'];
};

export type PimPricingSettings = {
  enable: Scalars['Boolean'];
  hierarchies: PimPricingHierarchies;
};

export type Price = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type PriceListInfo = {
  id: Scalars['String'];
  listName: Scalars['String'];
};

export type PriceListRecap = {
  currentNode?: Maybe<SearchNode>;
  nodes: NodeResult;
};

export type PriceSetting = {
  dealer_gp: Price;
  dealer_ms: Price;
  dealer_price: Price;
  dn: Price;
  dnWithDelta: Price;
  dn_cash_d: Price;
  extra_discount: Price;
  forced_dealer_gp: Price;
  forced_dealer_price: Price;
  forced_gp: Price;
  forced_tpa: Price;
  forced_vn: Price;
  gl_list_price: Price;
  gl_tpa: Price;
  gp: Price;
  gp_ms: Price;
  gp_tpa: Price;
  lc: Price;
  list_price: Price;
  markup: Price;
  mo: Price;
  ms: Price;
  standard_price_delta: Price;
  tpa: Price;
  transport_costs: Price;
};

export type ProductInfoMutationType = {
  code: Scalars['String'];
  contentTypeGroups: Array<ContentTypeGroup>;
  id: Scalars['String'];
};

export type Prototype = {
  contentTypes: PrototypeContentTypes;
  defaultColumns?: Maybe<Array<PrototypeContentType>>;
  enable: Scalars['Boolean'];
  fallbackCurrency?: Maybe<Scalars['String']>;
  filterContentTypeGroup?: Maybe<Scalars['String']>;
  hideCreatePrototype?: Maybe<Scalars['Boolean']>;
  hierarchies?: Maybe<PrototypeHierarchies>;
  modelSelectionLayout?: Maybe<Scalars['String']>;
  modelSelectionSidebarWidth?: Maybe<Scalars['String']>;
  optionFilters?: Maybe<OptionFiltersSettings>;
  phaseOut?: Maybe<PhaseOutSettings>;
};

export type PrototypeCertifications = {
  date: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  statusLabel?: Maybe<Scalars['String']>;
  user: Scalars['String'];
};

export type PrototypeContentType = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
};

export type PrototypeContentTypes = {
  configuratorApiKey?: Maybe<PrototypeContentType>;
  configuratorBaseUrl?: Maybe<PrototypeContentType>;
  configuratorPackagePath?: Maybe<PrototypeContentType>;
  configuratorType?: Maybe<PrototypeContentType>;
  configuratorViewId?: Maybe<PrototypeContentType>;
  itemType?: Maybe<PrototypeContentType>;
  listPrice?: Maybe<PrototypeContentType>;
  modelDescription?: Maybe<PrototypeContentType>;
  modelImage?: Maybe<PrototypeContentType>;
  modelName?: Maybe<PrototypeContentType>;
  modelOptions: Array<PrototypeContentType>;
  optionCost?: Maybe<PrototypeContentType>;
  optionPrice?: Maybe<PrototypeContentType>;
  optionWarning?: Maybe<OptionWarning>;
  phasedIn?: Maybe<PrototypeContentType>;
  phasedOut?: Maybe<PrototypeContentType>;
  prototypeOptions?: Maybe<PrototypeContentType>;
  replacedBy?: Maybe<PrototypeContentType>;
};

/**
 * Tells whether what a prototype has stored about its GLs still matches the GLs themselves. The
 * prototype keeps a snapshot of them (code, denomination, SAP characteristics, MM Dispo) that is
 * rebuilt only when the prototype is saved, so it goes stale as soon as a GL changes.
 */
export type PrototypeGlAlignment = {
  /** True when the prototype must be saved again for the current GL data to be applied. */
  outdated: Scalars['Boolean'];
  prototypeId: Scalars['String'];
};

export type PrototypeGlData = {
  link: Scalars['String'];
  value: PrototypeGlDataValue;
};

export type PrototypeGlDataValue = {
  code: Scalars['String'];
  dealerGpWithSupports?: Maybe<Scalars['Int']>;
  dealer_gp?: Maybe<Scalars['Int']>;
  dealer_ms?: Maybe<Scalars['Int']>;
  dealer_price?: Maybe<Scalars['Int']>;
  denomination?: Maybe<Scalars['String']>;
  dn?: Maybe<Scalars['Int']>;
  dnCashDWithSupports?: Maybe<Scalars['Int']>;
  dnWithDelta?: Maybe<Scalars['Int']>;
  dnWithSupports?: Maybe<Scalars['Int']>;
  dn_cash_d?: Maybe<Scalars['Int']>;
  family?: Maybe<Scalars['String']>;
  forcedListPrice?: Maybe<Scalars['Int']>;
  forcedTransportCosts?: Maybe<Scalars['Int']>;
  glCode: Scalars['String'];
  gl_characteristics?: Maybe<Array<PrototypeGlDataValueGlCharacteristics>>;
  gl_list_price?: Maybe<Scalars['Int']>;
  gl_tpa?: Maybe<Scalars['Int']>;
  gp?: Maybe<Scalars['Int']>;
  gpWithSupports?: Maybe<Scalars['Int']>;
  lc?: Maybe<Scalars['Int']>;
  lcWithSupports?: Maybe<Scalars['Int']>;
  list_price?: Maybe<Scalars['Int']>;
  markup?: Maybe<Scalars['Int']>;
  markupWithSupports?: Maybe<Scalars['Int']>;
  mo?: Maybe<Scalars['Int']>;
  ms?: Maybe<Scalars['Int']>;
  selection?: Maybe<Scalars['Int']>;
  standard_price_delta?: Maybe<Scalars['Int']>;
  tpa?: Maybe<Scalars['Int']>;
  transport_costs?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type PrototypeGlDataValueGlCharacteristics = {
  code: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

/**
 * The forcings a prototype keeps on one of its GL selections. A flag left on keeps the forced value,
 * a flag switched off drops the marker so the selection realigns to the GL value.
 */
export type PrototypeGlForcedValues = {
  forceListPrice: Scalars['Boolean'];
  forceTransportCosts: Scalars['Boolean'];
  glId: Scalars['String'];
  /**
   * The list price to force. Read only when `forceListPrice` is on: omitting it keeps the value the
   * selection already forces, so it is only required to start forcing a prototype which follows the
   * GL.
   */
  listPrice?: InputMaybe<Scalars['String']>;
  prototypeId: Scalars['String'];
  /**
   * The transport charge to force. Read only when `forceTransportCosts` is on, with the same
   * fallback on the value the selection already forces.
   */
  transportCosts?: InputMaybe<Scalars['String']>;
};

export type PrototypeHierarchies = {
  configurationRules?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  modelSelection?: Maybe<Scalars['String']>;
  prototype: Scalars['String'];
  prototypeCompatibilities?: Maybe<Scalars['String']>;
};

export type PrototypeMmDispoError = {
  gls: Array<PrototypeMmDispoGl>;
  position: Scalars['String'];
};

export type PrototypeMmDispoGl = {
  code: Scalars['String'];
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PrototypeMmDispoGlSelectionInput = {
  glId: Scalars['String'];
  selection?: InputMaybe<Scalars['Int']>;
};

/**
 * The GL selections a prototype is about to be saved with. When passed, the MM Dispo check evaluates
 * these instead of the selections stored on the prototype, so it reflects edits not yet saved.
 */
export type PrototypeMmDispoSelectionInput = {
  prototypeId: Scalars['String'];
  selections: Array<PrototypeMmDispoGlSelectionInput>;
};

export type PrototypeMmDispoValue = {
  gl?: Maybe<PrototypeMmDispoGl>;
  position: Scalars['String'];
};

export type PrototypeMediaCategoryMapping = {
  brochure: Scalars['String'];
  image: Scalars['String'];
  other: Scalars['String'];
};

export type PrototypeSetting = {
  certificationStatuses: CertificationStatus;
  glCodes: Array<Scalars['String']>;
  modelCode: Scalars['String'];
  objectSchemaCode: Scalars['String'];
  priceCodes: PriceSetting;
  prototypeHierarchyId: Scalars['String'];
};

export type PrototypeUpdateMutationResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PublishNodeResult = {
  hierarchyId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PublishResponse = {
  /** publishLongList only: the schede master brought in line with the published scheda. */
  masterPropagation?: Maybe<Array<MasterPropagationResult>>;
  /**
   * publishLongList only: why the schede master could not be brought in line, when the lookup of the
   * masters or the export of the scheda after them failed. The scheda is published either way.
   */
  masterPropagationError?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PublishTarget = {
  contentTypeGroups: Array<Scalars['String']>;
  hierarchy: Scalars['String'];
  node: Scalars['String'];
};

export type PublishWithRelatedResponse = {
  results: Array<PublishNodeResult>;
  success: Scalars['Boolean'];
};

export type PublishedContentTypeGroup = {
  contentTypeGroup: Scalars['String'];
  contents: Array<NodeContentO>;
};

export type PublishedNode = {
  code: Scalars['String'];
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  nodeId: Scalars['String'];
  parent: Scalars['String'];
  publishedAt: Scalars['String'];
  updatedBy: Scalars['String'];
  version: Scalars['Int'];
  withdrawn?: Maybe<Scalars['Boolean']>;
};

export type PublishedNodeContent = {
  contentTypeGroups: Array<PublishedContentTypeGroup>;
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type Query = {
  _empty?: Maybe<Scalars['String']>;
  breadcrumb: Array<BreadcrumbNode>;
  contentTranslation: Scalars['String'];
  contentType?: Maybe<ContentType>;
  contentTypeGroup?: Maybe<ContentTypeGroup>;
  getCascadeDeletePreview: CascadeDeletePreviewResult;
  getCompatibilityRulesGls: SearchResult;
  getCompatibilityRulesGlsObjectschemas: Array<ObjectSchema>;
  getCompatibilityRulesSchedaGls: Array<CompatibilityRuleGlSource>;
  getCompatiblePriceLists: CompatiblePriceList;
  getLinkedByFilterOptions: Array<LinkedByFilterOptionNode>;
  getLinkedByHierarchies: Array<LinkedByHierarchyResult>;
  getLinkedNodesForDelete: LinkedNodesForDeleteResult;
  /**
   * Ids of the schede whose matching_long_lists (schede abbinate) contain the given scheda: read from
   * the working nodes, or, for a published version document id, from the approved versions of the
   * other schede as they were while that version was the one in force.
   */
  getMasterLongLists: Array<Scalars['String']>;
  getMatchingLongLists: SearchResult;
  getNodeIdByCode?: Maybe<Scalars['String']>;
  /**
   * The schede master of a scheda whose published version disagrees with their draft: masters added
   * (the draft lists the scheda, the published version does not) or removed (the other way round).
   * Publishing the scheda brings them in line.
   */
  getPendingMasterLongLists: Array<PendingMasterLongList>;
  getPrototypeCertifications: Array<PrototypeCertifications>;
  getPrototypeCompatibilityCandidates: SearchResult;
  getPrototypeCompatibilityCandidatesObjectSchemas: Array<ObjectSchema>;
  getPrototypeGlVersions: GlVersions;
  getPrototypes: Array<HierarchyNode>;
  getPrototypesGlAlignment: Array<PrototypeGlAlignment>;
  getPrototypesMMDispoValidity: Array<MmDispoValidity>;
  getPrototypesSearchData: SearchResult;
  getPrototypesSearchDataObjectSchemas: Array<ObjectSchema>;
  getPublishedContent: PublishedNodeContent;
  getPublishedNodeVersions: Array<PublishedNode>;
  getRelatedUnpublishedNodes: Array<RelatedUnpublishedNode>;
  getSelectedDgs: Array<SelectedDgs>;
  getSelectedGls: Array<SelectedGl>;
  getShortListBuildupDiff: Array<BuildUpDiff>;
  getShortlistSAPLegend: Array<ShortlistSapLegendItem>;
  getShortlistsObjectschemas: Array<ObjectSchema>;
  getShortlistsPrototypes: SearchResult;
  glCharacteristics: Array<GlCharacteristic>;
  glItems: CheckResponse;
  glLinkedModelsInfo: Array<LinkedModelGlInfo>;
  glMismatch: Array<Scalars['String']>;
  globalSearch: GlobalSearchResponse;
  hierarchies?: Maybe<Array<Hierarchy>>;
  hierarchyHistory: HierarchyHistoryResult;
  inheritAncestorNode: Scalars['String'];
  invalidGls: Array<InvalidGl>;
  isFavorite: Scalars['Boolean'];
  languages?: Maybe<Array<Language>>;
  modelGlsStatuses: Array<ModelGlStatuses>;
  modelHasDisabledItems: Scalars['Boolean'];
  /**
   * The node as it stood at `date` (ISO string or epoch milliseconds), or right after `event` (the
   * id of an event of its history), rebuilt from its history, with the object schema of that date
   * and the nodes its link contents pointed to then. `event` wins when both are given: imported
   * events can carry back-dated timestamps, so an event is a more reliable point than its date.
   */
  nodeAtDate: NodeAtDateResult;
  /**
   * The node rebuilt at two points of its history, each a date (`from`, `to`: ISO strings or epoch
   * milliseconds) or an event (`fromEvent`, `toEvent`), with what changed between them.
   */
  nodeAtDateDiff: NodeAtDateDiff;
  nodeList: SearchResult;
  /** Notification definitions for the current user's company (admin-only, PIM_SUPERADMIN). */
  notificationDefinitions: Array<NotificationDefinition>;
  /**
   * Visibility-filtered notifications for the current user, newest-first.
   * onlyUnread defaults to true; pass false to also include already-read notifications.
   * language is the client locale used to resolve the title/message (falls back to the company
   * default language, then to any available language).
   */
  notifications: Array<Notification>;
  objectSchemas: Array<ObjectSchema>;
  priceListRecap: PriceListRecap;
  priceListRecapObjectSchemas: Array<ObjectSchema>;
  prices: Array<Price>;
  prototypeCount: Scalars['Int'];
  searchHierarchies: SearchResult;
  settings: Setting;
  unreadNotificationCount: Scalars['Int'];
};


export type QueryBreadcrumbArgs = {
  hierarchyId?: InputMaybe<Scalars['String']>;
  nodeId?: InputMaybe<Scalars['String']>;
};


export type QueryContentTranslationArgs = {
  content: Scalars['String'];
  fromIsoCode: Scalars['String'];
  toIsoCode: Scalars['String'];
  type: Scalars['String'];
};


export type QueryContentTypeArgs = {
  aggregateId: Scalars['String'];
  fieldCode: Scalars['String'];
  groupCode: Scalars['String'];
};


export type QueryContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
};


export type QueryGetCascadeDeletePreviewArgs = {
  hierarchyId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  linkingHierarchyId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCompatibilityRulesGlsArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGetCompatibilityRulesSchedaGlsArgs = {
  schedaVersionId: Scalars['String'];
};


export type QueryGetCompatiblePriceListsArgs = {
  glId: Scalars['String'];
  modelId: Scalars['String'];
};


export type QueryGetLinkedByFilterOptionsArgs = {
  filters: Array<SearchFilter>;
  hierarchyIds: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkingHierarchyId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetLinkedByHierarchiesArgs = {
  depth?: InputMaybe<Scalars['String']>;
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type QueryGetLinkedNodesForDeleteArgs = {
  hierarchyId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  linkingHierarchyId?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetMasterLongListsArgs = {
  longListId: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};


export type QueryGetMatchingLongListsArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGetNodeIdByCodeArgs = {
  hierarchyId: Scalars['String'];
  nodeCode: Scalars['String'];
};


export type QueryGetPendingMasterLongListsArgs = {
  longListId: Scalars['String'];
};


export type QueryGetPrototypeCertificationsArgs = {
  glId?: InputMaybe<Scalars['String']>;
  prototypeId: Scalars['String'];
};


export type QueryGetPrototypeCompatibilityCandidatesArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGetPrototypeGlVersionsArgs = {
  certificationIds: Array<Scalars['String']>;
  glId: Scalars['String'];
};


export type QueryGetPrototypesArgs = {
  modelId: Scalars['String'];
};


export type QueryGetPrototypesGlAlignmentArgs = {
  modelId: Scalars['String'];
};


export type QueryGetPrototypesMmDispoValidityArgs = {
  modelId: Scalars['String'];
  pendingSelections?: InputMaybe<Array<PrototypeMmDispoSelectionInput>>;
};


export type QueryGetPrototypesSearchDataArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGetPrototypesSearchDataObjectSchemasArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetPublishedContentArgs = {
  contentTypeGroup?: InputMaybe<Scalars['String']>;
  hierarchy: Scalars['String'];
  node: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};


export type QueryGetPublishedNodeVersionsArgs = {
  hierarchyId: Scalars['String'];
  nodeIds: Array<Scalars['String']>;
};


export type QueryGetRelatedUnpublishedNodesArgs = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type QueryGetSelectedDgsArgs = {
  dgsIds: Array<Scalars['String']>;
  modelId: Scalars['String'];
};


export type QueryGetSelectedGlsArgs = {
  glIds: Array<Scalars['String']>;
  modelId: Scalars['String'];
};


export type QueryGetShortListBuildupDiffArgs = {
  shortListId: Scalars['String'];
};


export type QueryGetShortlistSapLegendArgs = {
  familyId: Scalars['String'];
};


export type QueryGetShortlistsObjectschemasArgs = {
  metadata?: InputMaybe<ObjectSchemasMetadata>;
};


export type QueryGetShortlistsPrototypesArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGlItemsArgs = {
  glNodeId?: InputMaybe<Scalars['String']>;
  glType: Scalars['String'];
  itemValues?: InputMaybe<Array<Scalars['NodeValue']>>;
  modelId: Scalars['String'];
};


export type QueryGlLinkedModelsInfoArgs = {
  glId: Scalars['String'];
  modelId: Scalars['String'];
};


export type QueryGlMismatchArgs = {
  priceListId: Scalars['String'];
};


export type QueryGlobalSearchArgs = {
  contentSource?: InputMaybe<ContentSource>;
  languageIsoCode?: InputMaybe<Scalars['String']>;
  searchTerm: Scalars['String'];
};


export type QueryHierarchiesArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryHierarchyHistoryArgs = {
  hierarchy: Scalars['String'];
  node: Scalars['String'];
  pagination: Pagination;
};


export type QueryInheritAncestorNodeArgs = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type QueryInvalidGlsArgs = {
  modelId: Scalars['String'];
  priceListId: Scalars['String'];
};


export type QueryIsFavoriteArgs = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type QueryLanguagesArgs = {
  isoCode?: InputMaybe<Scalars['String']>;
};


export type QueryModelGlsStatusesArgs = {
  glIds?: InputMaybe<Array<Scalars['String']>>;
  modelId: Scalars['String'];
};


export type QueryModelHasDisabledItemsArgs = {
  modelId: Scalars['String'];
};


export type QueryNodeAtDateArgs = {
  date?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
  hierarchy: Scalars['String'];
  node: Scalars['String'];
};


export type QueryNodeAtDateDiffArgs = {
  from?: InputMaybe<Scalars['String']>;
  fromEvent?: InputMaybe<Scalars['String']>;
  hierarchy: Scalars['String'];
  node: Scalars['String'];
  to?: InputMaybe<Scalars['String']>;
  toEvent?: InputMaybe<Scalars['String']>;
};


export type QueryNodeListArgs = {
  filter: Array<SearchFilter>;
  id?: InputMaybe<Scalars['String']>;
  isInTranslation?: InputMaybe<Scalars['Boolean']>;
  nodeId?: InputMaybe<Scalars['String']>;
  pagination: Pagination;
  withBreadcrumbs?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNotificationsArgs = {
  language?: InputMaybe<Scalars['String']>;
  onlyUnread?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPriceListRecapArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  originHierarchyId?: InputMaybe<Scalars['String']>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryPriceListRecapObjectSchemasArgs = {
  metadata?: InputMaybe<ObjectSchemasMetadata>;
};


export type QueryPricesArgs = {
  contentTypeGroupCode: Scalars['String'];
  hierarchyId: Scalars['String'];
};


export type QueryPrototypeCountArgs = {
  modelId: Scalars['String'];
};


export type QuerySearchHierarchiesArgs = {
  contentSource?: InputMaybe<ContentSource>;
  contentTypes?: InputMaybe<Array<Scalars['String']>>;
  disableNodesTransformation?: InputMaybe<Scalars['Boolean']>;
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  linkedByColumns?: InputMaybe<LinkedByColumnsInput>;
  originNode?: InputMaybe<OriginNode>;
  pagination: Pagination;
  sort: Array<Sort>;
};

export type RelatedUnpublishedNode = {
  code: Scalars['String'];
  contentTypeGroupStatus?: Maybe<Array<ContentTypeGroupStatus>>;
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  listName?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
  nodePublished: CtgStatus;
};

export type SearchDataPagination = {
  defaultPageSize: Scalars['Int'];
  pageSizes: Array<Scalars['Int']>;
};

export type SearchFilter = {
  field: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  linkedHierarchy?: InputMaybe<Scalars['String']>;
  operator: SearchFilterOperator;
  value: Array<Scalars['String']>;
};

export enum SearchFilterOperator {
  Contains = 'contains',
  EndsWith = 'endsWith',
  Equals = 'equals',
  ExactMatch = 'exactMatch',
  GreaterThan = 'greaterThan',
  GreaterThanEqual = 'greaterThanEqual',
  Includes = 'includes',
  IsAnyOf = 'isAnyOf',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  LessThan = 'lessThan',
  LessThanEqual = 'lessThanEqual',
  NotEquals = 'notEquals',
  StartsWith = 'startsWith'
}

export type SearchNode = {
  _rev?: Maybe<Scalars['String']>;
  assignedClient?: Maybe<AssignedNodeRef>;
  assignedDealership?: Maybe<AssignedNodeRef>;
  assignedMarket?: Maybe<AssignedNodeRef>;
  assignedOwner?: Maybe<AssignedNodeRef>;
  breadcrumb?: Maybe<Array<BreadcrumbNode>>;
  code: Scalars['String'];
  contentTypeGroupStatus?: Maybe<Array<ContentTypeGroupStatus>>;
  contents: Array<NodeContentO>;
  createdAt: Scalars['Float'];
  depth?: Maybe<Scalars['Int']>;
  disabled: Scalars['Boolean'];
  firstNodeStatus?: Maybe<Scalars['String']>;
  hierarchy: Scalars['String'];
  hierarchyCode: Scalars['String'];
  id: Scalars['String'];
  /** The listName of each node the link contents point to; filled only when selected. */
  linkListNames?: Maybe<Array<LinkListName>>;
  linkedBy?: Maybe<Array<Maybe<LinkedBy>>>;
  /** Set only when `searchHierarchies` is called with `linkedByColumns`. */
  linkedByColumns?: Maybe<Array<LinkedByColumnGroup>>;
  listName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  nodePublished: CtgStatus;
  order?: Maybe<Scalars['String']>;
  parent: Scalars['String'];
  parentCode: Scalars['String'];
  readRoles?: Maybe<Array<Scalars['String']>>;
  readUsers?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['Float'];
  writeRoles?: Maybe<Array<Scalars['String']>>;
  writeUsers?: Maybe<Array<Scalars['String']>>;
};

export type SearchNodeEdge = {
  cursor: Scalars['String'];
  node: SearchNode;
};

export type SearchResult = {
  bulkPublish?: Maybe<Scalars['Boolean']>;
  currentNode?: Maybe<SearchNode>;
  enablePublish?: Maybe<Scalars['Boolean']>;
  nodes: NodeResult;
  showPublishInfo?: Maybe<Scalars['Boolean']>;
};

export type SelectOptionValues = {
  code: Scalars['String'];
  value: Array<OptionValue>;
};

export type SelectOptionValuesInput = {
  code: Scalars['String'];
  value: Array<OptionValueInput>;
};

export type SelectedDgs = {
  base_unit: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  hierarchyId: Scalars['String'];
  id: Scalars['String'];
  list_price: Scalars['String'];
  material: Scalars['String'];
};

export type SelectedGl = {
  code: Scalars['String'];
  denomination: Scalars['String'];
  description: Scalars['String'];
  family: Scalars['String'];
  hierarchyId: Scalars['String'];
  id: Scalars['String'];
  items: Array<SelectedGlItem>;
  type: Scalars['String'];
};

export type SelectedGlItem = {
  id: Scalars['String'];
  positionType: ItemPositionType;
  quantity: Scalars['String'];
};

export type Setting = {
  appBar?: Maybe<Scalars['JSON']>;
  cadPreview?: Maybe<CadPreviewSettings>;
  cgtSettings?: Maybe<CgtSettings>;
  channels?: Maybe<Array<ChannelSetting>>;
  cpq?: Maybe<CpqSettings>;
  createHierarchyRoles?: Maybe<Array<Scalars['String']>>;
  crm?: Maybe<CrmSettings>;
  customPages?: Maybe<Array<CustomPage>>;
  defaultPageUri?: Maybe<DefaultPageUriConfig>;
  enableAI: Scalars['Boolean'];
  enableBulkChangeRules?: Maybe<Scalars['Boolean']>;
  enableContentTranslation: Scalars['Boolean'];
  enableExternalCallLog?: Maybe<Scalars['Boolean']>;
  enableExternalSystemRequestLogger?: Maybe<Scalars['Boolean']>;
  enableFavorite?: Maybe<Scalars['Boolean']>;
  enableFindReplace?: Maybe<Scalars['Boolean']>;
  enableSearch: Scalars['Boolean'];
  enableSearchCellEditing?: Maybe<Scalars['Boolean']>;
  enableUserAnalytics?: Maybe<Scalars['Boolean']>;
  favoriteRoles?: Maybe<FavoriteRoles>;
  fiammSettings?: Maybe<FiammSettings>;
  globalSearch?: Maybe<GlobalSearchSettings>;
  hasFieldEncryptionKey?: Maybe<Scalars['Boolean']>;
  hiddenNodeActions?: Maybe<Scalars['JSON']>;
  hierarchiesPageRoles?: Maybe<Array<Scalars['String']>>;
  jobList?: Maybe<Array<Scalars['String']>>;
  jsonataDependenciesEnabled?: Maybe<Scalars['Boolean']>;
  media?: Maybe<MediaSettings>;
  nodeActionsPlacement?: Maybe<Scalars['JSON']>;
  pimPricing?: Maybe<PimPricingSettings>;
  prototype?: Maybe<Prototype>;
  publishedContentSourceEnabled?: Maybe<Scalars['Boolean']>;
  searchDataPagination?: Maybe<SearchDataPagination>;
  sidelSettings?: Maybe<SidelSettings>;
  theme?: Maybe<ThemeSetting>;
  trackPublishedDocuments?: Maybe<Scalars['Boolean']>;
  userManagement?: Maybe<UserManagementSettings>;
  variantPricingEnabled?: Maybe<Scalars['Boolean']>;
};

export type ShortListDetails = {
  color: Scalars['String'];
  endValidityDate: Scalars['String'];
  /**
   * Day (YYYY-M-D) the shortlist data is frozen at: when set, the shortlist is locked and
   * every read uses the prototype certifications closest to, and not after, that day.
   */
  freezeDate?: InputMaybe<Scalars['String']>;
  month: Scalars['String'];
  name: Scalars['String'];
  preset: Scalars['String'];
  segment: Scalars['String'];
  startValidityDate: Scalars['String'];
  year: Scalars['String'];
};

export type ShortListEditableHeadersInput = {
  alias: Scalars['String'];
  code: Scalars['String'];
};

export type ShortListLegendItemInput = {
  code: Scalars['String'];
  hideInExport: Scalars['Boolean'];
  value: Scalars['String'];
};

export type ShortListPdfColumnInput = {
  code: Scalars['String'];
  fill?: InputMaybe<Scalars['Boolean']>;
  visible: Scalars['Boolean'];
  width?: InputMaybe<Scalars['Float']>;
};

export type ShortlistSapLegendItem = {
  code: Scalars['String'];
  hideInExport: Scalars['Boolean'];
  isMMDispo?: Maybe<Scalars['Boolean']>;
  isSaved?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type SidelSettings = {
  boomi?: Maybe<SidelSettingsBoomi>;
  hierarchies?: Maybe<SidelSettingsHierarchy>;
};

export type SidelSettingsBoomi = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SidelSettingsHierarchy = {
  commercialItems: Scalars['String'];
  massiveCheckPrefix?: Maybe<Scalars['String']>;
};

export type Sort = {
  field: Scalars['String'];
  sort: SortOrder;
  type?: InputMaybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Sql = {
  database: Scalars['String'];
  host: Scalars['String'];
  password: Scalars['String'];
  port?: Maybe<Scalars['Int']>;
  table?: Maybe<Scalars['String']>;
  user: Scalars['String'];
};

export type Subscription = {
  /**
   * Real-time signal of the changes of one agent run. WebSocket subscriptions are not routed
   * through the HTTP auth middleware, so the payload is limited to the run id, status and step
   * sequence number; the run itself is only readable through the REST API, which checks the owner.
   */
  agentRunUpdated: AgentRunUpdate;
  eventCreated: SubscriptionEvent;
  jobFinished: JobFinishedInfo;
  nodesUpdated: NodeUpdate;
  /**
   * Real-time push of newly-created notifications the subscriber is entitled to see.
   * The subscriber's identity is passed explicitly because WebSocket subscriptions are not
   * routed through the HTTP auth middleware; the authoritative visibility is still enforced by
   * the `notifications` query. Values mirror the caller's session (company, username, dealerships,
   * roles) and are used to apply the same visibility predicate as the read query.
   */
  notificationCreated: Notification;
  /**
   * Fires when the subscriber marks notifications as read (in any tab/device), so every other
   * session of the same user can drop them from the unread badge and list. Strictly personal:
   * events of other users are never forwarded (read state is per-user and never shared).
   */
  notificationRead: NotificationReadEvent;
};


export type SubscriptionAgentRunUpdatedArgs = {
  runId: Scalars['ID'];
};


export type SubscriptionEventCreatedArgs = {
  hierarchyId?: InputMaybe<Scalars['String']>;
  nodeId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionJobFinishedArgs = {
  company?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};


export type SubscriptionNodesUpdatedArgs = {
  hierarchyIds: Array<Scalars['String']>;
  nodeIds: Array<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};


export type SubscriptionNotificationCreatedArgs = {
  company: Scalars['String'];
  dealerships?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
};


export type SubscriptionNotificationReadArgs = {
  userId: Scalars['String'];
};

export type SubscriptionEvent = {
  edits: Array<Edit>;
};

export type ThemeSetting = {
  bgColor?: Maybe<Scalars['String']>;
  fontFamily?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  sidebarWidth?: Maybe<Scalars['String']>;
};

export type ToggleFavoriteResponse = {
  isFavorite: Scalars['Boolean'];
};

export type UpdatePermissionsResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
  /**
   * Set when the permissions reach the descendants of the node through a background job: the node
   * itself is already updated, its subtree follows (track it with the jobFinished subscription).
   */
  propagationJobId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UserManagementSettings = {
  dealershipHierarchyId?: Maybe<Scalars['String']>;
  hierarchyId: Scalars['String'];
};

export type Visibility = {
  operator?: Maybe<Scalars['String']>;
  visibilityRules?: Maybe<Array<VisibilityRule>>;
};

export type VisibilityInput = {
  operator: Scalars['String'];
  visibilityRules?: InputMaybe<Array<VisibilityRuleInput>>;
};

export type VisibilityRule = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  value: Scalars['String'];
};

export type VisibilityRuleInput = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  value: Scalars['String'];
};

export type WarrantyPublishSetting = {
  concurrency?: Maybe<Scalars['Int']>;
  maxConsecutiveBoomiFailedChunks?: Maybe<Scalars['Int']>;
  maxPerHour?: Maybe<Scalars['Int']>;
  unavailableRetryDelaysMinutes?: Maybe<Array<Scalars['Float']>>;
};

export type UpdateContentTypeGroupInput = {
  approveRoles?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  collapsed: Scalars['Boolean'];
  name: Array<NameObjectI>;
  repeatable: Scalars['Boolean'];
  roles?: InputMaybe<Scalars['String']>;
  showLevel?: InputMaybe<Scalars['String']>;
  viewRoles?: InputMaybe<Array<Scalars['String']>>;
};
